<template>
  <div class="main-wrap" :key="mainKey">
    <div hidden>
      <v-form-component />
      <v-textarea />
      <v-date-time />
      <v-combo />
    </div>
    <v-alert></v-alert>
    <!-- {{
      shipmentObject.model.estimate["non-binding"].shipment_service[0]
        .special_instructions
    }}
    cur model:{{ currentModel }}-->
    <v-snackbar
      v-if="successMessage && saveButtonCaption == 'Save Move Plan'"
      v-model="successMessage"
      :timeout="3000"
      color="success"
    >
      {{ successMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="successMessage = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar
      v-if="$root.customerId"
      v-model="showCustomMessage"
      :timeout="3000"
      color="success"
    >
      {{ customMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="showCustomMessage = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <!-- <v-btn @click="postToCallTools()">Post To Calltools</v-btn> -->
    <v-dialog v-model="itemDialog" persistent max-width="450">
      <v-card>
        <v-card-title class="text-h5"> Confirm Item Handling </v-card-title>
        <v-card-text>{{ handlingPrompt }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="applyHandling"> Yes </v-btn>
          <v-btn
            color="danger"
            text
            @click="
              itemDialog = false;
              currentItemHandlingId = null;
            "
          >
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      :width="photoProperties.cameraWidth"
      style="background-color: white"
      v-model="photoDialog"
    >
      <v-card>
        <v-toolbar flat style="background-color: transparent"
          ><v-spacer></v-spacer
          ><v-btn text small @click="photoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-take-photo v-bind="photoProperties" v-if="photoDialog"></v-take-photo
      ></v-card>
    </v-dialog>
    <v-movable-dialog
      ref="moveDialog"
      :close="closeVisualInventory"
      title="Visual Inventory"
      v-if="showVisualInventory"
    >
      <!-- Your custom content here -->

      <visual-inventory
        v-if="!$root.customerId"
        :customer="
          shipmentObject.model.customer.contact.first_name +
            ' ' +
            shipmentObject.model.customer.contact.last_name
        "
        :client_id="shipmentObject.model.customer.calltools_contact_id"
        :email="shipmentObject.model.customer.contact.email"
        :customerPhone="
          shipmentObject.model.customer.contact.phones.mobile
            ? shipmentObject.model.customer.contact.phones.mobile.phone_number
            : ''
        "
        :company="getCompanyName()"
        :companyId="company.company_id"
        :company_id="company._id"
        :comp="true"
        :sendMail="$root.sendMail"
        :sendSMS="$root.sendSMS"
        :uploadVideo="uploadVideo"
        :serverUrl="serverURL"
      ></visual-inventory>
    </v-movable-dialog>
    <v-toolbar v-if="!$root.customerId" flat>
      <h3 style="font-weight: normal">{{ getCaption() }}</h3>
      <v-spacer></v-spacer>

      <v-menu-button
        id="letters"
        :displayTable="true"
        :hasSearch="true"
        :key="letterKey"
        searchLabel="Search Letters"
        v-if="planReady && !readonly && !$root.customerId"
        v-bind="letterMenuBtn"
      ></v-menu-button>
    </v-toolbar>

    <div v-if="loading">
      <v-loader
        :loadingElements="loadingElements"
        :text="loadingText"
      ></v-loader>
    </div>
    <!-- activeTabIndex:{{ activeTabIndex }} -->
    <v-row>
      <v-col v-if="activeTabIndex && $root.isMobile">
        <v-row
          ><v-col
            ><v-btn class="ml-2" text color="info" @click="activeTabIndex = 0">
              <v-icon>mdi-home</v-icon>
            </v-btn></v-col
          ><v-col>
            <h5 class="ml-4">
              {{ dataTabs[activeTabIndex - 1].obj.title }}
            </h5></v-col
          ></v-row
        >
      </v-col>

      <v-col cols="12">
        <v-tabs
          v-if="!$root.isMobile"
          v-on:touchstart="handleTouchStart"
          v-on:touchmove="handleTouchMove"
          class="pa-0"
          v-model="activeTabIndex"
          align-with-title
          show-arrows
          :grow="dataTabs.length"
          ref="tabs"
          :color="getColor()"
        >
          <v-tabs-slider color="warning"></v-tabs-slider>

          <v-tab>
            <v-icon class="ma-2" v-if="!activeTabIndex || !$root.isMobile"
              >mdi-home</v-icon
            >Move Plan</v-tab
          >

          <v-tab @click="reload(i, true)" v-for="(t, i) in dataTabs" :key="i">
            <v-icon
              class="mr-2"
              left
              :small="$vuetify.breakpoint.lgAndUp"
              v-if="t.icon"
              >{{ t.icon }}</v-icon
            >
            <div>{{ t.tabTitle }}</div>
            <v-btn
              v-if="$vuetify.breakpoint.lgAndUp"
              icon
              @click="removeTab(i)"
              class="ml-2"
            >
              <v-icon x-small>mdi-close</v-icon>
            </v-btn>
          </v-tab>
        </v-tabs>

        <v-tabs-items touchless v-model="activeTabIndex">
          <v-tab-item class="text-center">
            <v-move-plan
              :key="movePlanKey"
              :postToApp="postToApp"
              :refreshShipment="refreshShipment"
              ref="movePlan"
              v-if="planReady && !loading"
              :shipmentObject="shipmentObject"
              :getModel="getModel"
              :getMenu="getMenu"
              :menuItemClick="menuItemClick"
              :deleteUnit="deleteUnit"
              :hasOriginStorage="hasOriginStorage"
              :hasDestinationStorage="hasDestinationStorage"
              :formatStopValue="formatStopValue"
              :readOnlyObj="readOnlyObj"
              :crmTypes="crmTypes"
              :topUnits="menu"
              :storage="storage"
              :totalEstimate="totalEstimate"
              :balance="balance"
              :totalPayment="totalPayment"
              :showTab="showTab"
              :volume="model ? model.volume : 0"
              :letterMenuBtn="letterMenuBtn"
              :statusMenuBtn="statusMenuBtn"
              :bookBtn="bookBtn"
              :deliveryStatus="deliveryStatus"
              :readonly="readonly"
              :notesAndSms="notesAndSms"
              :shipmentClosed="shipmentClosed"
              :getLocationFromWarehouse="getLocationFromWarehouse"
            ></v-move-plan>
          </v-tab-item>
          <!-- dataTabs:{{ dataTabs }} -->

          <v-tab-item v-for="(t, i) in dataTabs" :key="i">
            <v-card v-if="!loading" :flat="!$vuetify.breakpoint.lgAndUp">
              <v-tabs
                v-if="isClosing && services.length > 1"
                align-with-title
                show-arrows
                grow
                v-model="serviceIndex"
              >
                <v-tab v-model="serviceIndex" v-for="s in services" :key="s._id"
                  >{{ capitalize(s.service_type) }} {{ s.service_date }}
                </v-tab></v-tabs
              >

              <v-card-text class="current-model-content">
                <v-form flat ref="form" v-if="!t.letterBind" lazy-validation>
                  <!-- <v-form-card
                    :dObject="shipmentObject"
                    ref="form"
                    :panels="true"
                    :mainTab="mainTab"
                    :key="formKey"
                    :actionFixedPosition="true"
                  ></v-form-card> -->
                  <!-- <v-form-wrapper
                    :hasParent="shipment_id != 0"
                    :computedCurrentModel="computedCurrentModel"
                    :currentSchema="currentSchema"
                    :shipmentObject="shipmentObject"
                    :onValueChange="onValueChange"
                    class="mb-2 mt-n2 pa-0"
                    :compclass="'mb-n4 mt-n2 pa-0'"
                    :key="formKey"
                    :mainTab="mainTab"
                    :noMainTabs="false"
                    :changeTab="changeTab"
                    :shipment_id="shipment_id"
                    :toolBarControls="toolBarControls"
                  ></v-form-wrapper> -->
                  <!-- <iframe
                    v-if="modelReady"
                    ref="iframe"
                    :src="'#/form-wrapper/' + shipment_id"
                    width="100%"
                    height="600px"
                  ></iframe> -->
                  <!-- {{
                    computedCurrentModel.shipment_service.special_instructions
                  }}
                  <v-textarea
                    v-model="
                      computedCurrentModel.shipment_service.special_instructions
                    "
                    v-for="i in 5"
                    :key="i"
                  ></v-textarea> -->
                  <!-- shipmentObject.model -->
                  <!-- {{ shipmentObject.model }} computedCurrentModel -->
                  <!-- {{ computedCurrentModel }} -->
                  <!-- currentSchema
                  {{
                    currentSchema.shipment_service["v-bind"]
                  }} -->
                  <!-- currentSchema:{{ currentSchema }}  -->

                  <!-- computedCurrentModel:{{ computedCurrentModel }} -->

                  <!-- <v-form-card
                    :dObject="shipmentObject"
                    v-bind="{ mainTabs: mainTabs }"
                  ></v-form-card> -->

                  <v-form-component
                    :hasParent="shipment_id != 0"
                    v-if="modelReady"
                    :model="currentModel"
                    :parentModel="shipmentObject ? shipmentObject.model : null"
                    :schema="currentSchema"
                    :data_object="shipmentObject"
                    :onValueChange="onValueChange"
                    class="mb-2 mt-n2 pa-0"
                    :compclass="'mb-n4 mt-n2 pa-0'"
                    :key="formKey"
                    :mainTab="mainTab"
                    :noMainTabs="false"
                    :changeTab="changeTab"
                    :mainTabs="mainTabs"
                    :toolBarControls="toolBarControls"
                  ></v-form-component>
                </v-form>

                <v-document
                  ref="doc"
                  v-if="letterReady"
                  v-bind="t.letterBind"
                  :key="docKey"
                ></v-document
              ></v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
    <v-app-bar
      v-if="activeTabIndex || systemMessage"
      class="bottom-bar"
      bottom
      app
    >
      <v-col class="text-center" cols="12">
        <v-alert
          class="ma-2"
          dismissible
          dense
          timeout="3000"
          v-if="errorMessage"
          type="error"
        >
          {{ errorMessage }}
        </v-alert>

        <v-row v-if="!mobileEdited" flat>
          <v-col>
            <v-btn
              @click="cancelWizard()"
              text
              left
              color="warning ma-2"
              v-if="wizardIndex > -1"
            >
              Skip Wizard
            </v-btn>
          </v-col>

          <v-col>
            <v-btn
              right
              :text="false"
              v-if="
                !isLetter &&
                  !isPayment &&
                  activeTabIndex != 0 &&
                  !readonly &&
                  !childEdited
              "
              :loading="loading"
              @click="submit(false)"
              color="success"
              class="save-button ma-2"
            >
              <v-icon class="ma-2">{{ saveButtonIcon }}</v-icon>
              {{ saveButtonCaption }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-app-bar>

    <v-snackbar color="info" :timeout="6000" v-model="snackbar">
      {{ snackbarMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="
            snackbar = false;
            snackbarMessage = '';
          "
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */

import * as fun from "../plugins/common";
import Vue from "vue";

import axios from "axios";
import errorsHandler from "../utils/errorsHandler";
import VFormComponent from "../components/FormComponent.vue";
export default {
  name: "Shipment",
  components: {
    VDocument: () => import("../components/Document.vue"),
    VMenuButton: () => import("../components/MenuButton.vue"),
    VFormComponent: () => import("../components/FormComponent.vue"),
    VMovePlan: () => import("../components/MovePlan.vue"),
    VCombo: () => import("../components/ComboBox.vue"),
    VShipmentMenuItems: () => import("../components/ShipmentMenuItems.vue"),
    VisualInventory: () => import("../components/VisualInventory.vue"),
    VLabelButton: () => import("../components/LabelButton.vue"),
    VLoader: () => import("../components//UI/Loader.vue"),
    VTakePhoto: () => import("../components/TakePhoto.vue"),
    VMovableDialog: () => import("../components/MovableDialog.vue"),
    VFormCard: () => import("../components/FormCard.vue"),
    // VFormWrapper: () => import("../components/FormWrapper.vue"),
  },
  props: {
    shipmentId: Number,
  },
  data() {
    return {
      testarea: "",
      systemMessage: false,
      itemDialog: false,
      photoDialog: false,
      photoProperties: {},
      handlingPrompt: "",
      currentItem: null,
      currentHandling: null,
      timeClicked: null,
      deliveryStatus: [],
      saveButtonIcon: "mdi-check",
      saveButtonCaption: "Save Move Plan",
      newEstimate: false,
      noWizard: false,
      wizardIndex: -1,
      wizardSteps: [
        {
          icon: "account",
          id: "shipper",
          obj: "shipper",
          objectName: "customer",
          title: "Shipper",
        },
        {
          icon: "home",
          id: "pickup",
          obj: "pickup",
          objectName: "address",
          title: "Pickup",
        },
        {
          icon: "home",
          id: "dropoff",
          obj: "dropoff",
          objectName: "address",
          title: "Dropoff",
        },
        {
          icon: "format-list-numbers",
          id: "inventory",
          obj: "inventory",
          objectName: "inventory",
          title: "Inventory",
        },
        {
          id: "job",
          icon: "truck",
          obj: "job",
          objectName: "shipment_service",
          title: "Job Detail and Estimate",
        },
      ],
      modelReady: false,
      shipmentMenuItemsProps: null,
      companyId: null,
      snackbar: false,
      snackbarMessage: "",
      company: null,
      drawer: 0,
      topDrawer: 0,
      zoneFrom: "",
      zoneTo: "",
      mainKey: 0,
      object_name: "v_shipment_with_zone_rate",
      loading: false,
      submitButtonCaption: "Save",
      topObject: true,
      shipment_id: 0,
      model_id: "",
      caption: "",
      data: null,
      data_object: {},
      formKey: 0,
      planReady: false,
      objectReady: false,
      required: [],
      parentProperties: null,
      model: {},
      parentModel: {},
      volume: 0,
      origin: null,
      destination: null,
      allLocations: [],
      inventory: [],
      shipmentRefreshed: false,
      addressUpdated: "",
      successMessage: "",
      successMessageValue: false,
      customMessage: "",
      showCustomMessage: false,
      formMessages: [],
      menu: [
        {
          key: "reload",
          title: "Reload Shipment",
          icon: "mdi-reload",
        },
      ],
      letterBody: "",
      letterKey: 0,
      letterModel: {},
      dialogVBind: null,
      errorMessage: "",
      statusBarColor: "",
      tableData: [],
      objects: [],
      loadedObjects: [],
      locations: [],
      stopKeys: [
        "_id",
        "crew_id",
        "job_id",
        "lead_id",
        "services",
        "stop_detail",
        "stop_number",
        "stop_type",
        "stoptype_id",
        "location_id",
        "service_id",
      ],
      testMode: false,
      init: false,
      originalModel: {},
      modifiedRecords: [],
      currentUser: "",
      dataTabs: [],
      activeTabIndex: 0,
      activeTab: null,
      addingTab: -1,
      shipmentObject: null,
      movePlanKey: 0,
      hasOriginStorage: false,
      hasDestinationStorage: false,
      currentModel: null,
      currentSchema: null,
      mainService: null,
      isLetter: null,
      isPayment: null,
      docKey: 0,
      tabKey: 0,
      serviceIndex: 0,
      lastAddresId: 0,
      showVisualInventory: false,
      deliveryDateFrame: 3,
      hideSendBtn: false,
      toolBarControls: null,
      readOnlyObj: ["balance", "totals"],
      totalPayment: 0,
      totalEstimate: 0,
      balance: 0,
      status: "",
      childEdited: false,
      shipmentClosed: false,
      mobileEdited: false,
      inventoryTable: null,
      crmTypes: [
        {
          caption: "Actions",
          name: "type",
          value: "action",
          color: "blue",
          hiddenHeaders: ["status"],
        },
        {
          caption: "Notes",
          name: "type",
          value: "note",
          color: "black",
          hiddenHeaders: ["action", "action_date_time", "status"],
          renameHeaders: [
            {
              description: "Note",
            },
          ],
        },
        {
          caption: "History",
          name: "type",
          value: "history",
          color: "red",
          hiddenHeaders: ["action", "action_date_time", "status"],
        },
        {
          caption: "Status Changed",
          name: "type",
          value: "status",
          color: "green",
          hiddenHeaders: ["action", "action_date_time"],
        },
      ],
      letterMenuBtn: {},
      statusMenuBtn: null,
      bookBtn: null,
      allPath: [],
      fixedModel: {},
      mainTabs: [],
      mainTab: 0,
      zoneRates: [],
      storage: [],
      perUnits: {
        cu_ft: "job_volume",
        lbs: "job_weight",
      },
      tab: null,
      showTabs: false,
      storageModel: null,
      letterReady: false,
      initDone: false,
      loadingElements: [document.getElementsByClassName("v-tabs")[0]],
      loadingText: "Loading...",
      formContainer: true,
      readonly: false,
      companyAssigned: false,
      currentItemHandlingId: null,
      canDeletePayment: false,
      notesAndSms: {},
      isClosing: false,
      services: [],
      lastModified: "",
      shipmentCharges: [],
      materialCharges: [],
      lastTab: null,
      linkedObjectSelected: false,
      visualInventoryDrawer: false,
      lastBtnClick: null,
      currentServceDate: null,
      noKeys: [
        "inventory",
        "payment",
        "attachments",
        "crm",
        "onsite_estimate",
        // "customer",
        // "address",
        // "shipment_service_labor",
        // "resources",
      ],
    };
  },
  activated() {
    this.$root.shipmentUid = this._uid;
    if (this.data) {
      if (!this.data.qry) {
        this.data.qry = {};
      }
      this.data.qry.shipment_id = parseInt(this.$route.params.id);
    }

    this.addAllEvents();
    if (this.$route.params.id == "0") {
      this.dataTabs = [];
      // this.$router.go();
      // if (!this.shipmentObject) {
      this.refreshShipment();
      //   this.initDone = false;
      // }
      this.saveButtonCaption = "Create Move Plan";
    } else {
      // if (!this.initDone) {
      this.initObject();
      // }
      // this.initDone = false;
    }
    this.recordActivities();
  },
  mounted() {
    var that = this;
    // this.checkSlideGesture();
    if (this.$router.currentRoute.params.id == "0") {
      this.noKeys.push("customer");
    } else {
      if (this.noKeys.indexOf("customer") != -1) {
        this.noKeys.splice(this.noKeys.indexOf("customer"), 1);
      }
    }
    if (this.$root.customerId) {
      var customerSteps = ["pickup", "dropoff", "inventory", "job"];
      this.wizardSteps.splice(0, 1);
      this.wizardSteps = this.wizardSteps.filter((w) => {
        return customerSteps.includes(w.id);
      });
    } else {
      this.useWizard = false;
      try {
        var portalSettings = this.$root.portal_settings[0];
        if (
          (portalSettings &&
            portalSettings.shipment_wizard &&
            portalSettings.shipment_wizard.use_wizard) ||
          this.$route.params.id == "0"
        ) {
          this.useWizard = true;
          this.wizardSteps = this.wizardSteps.filter((w) => {
            return (
              portalSettings.shipment_wizard.wizard_steps.includes(w.id) ||
              w.id == "shipper"
            );
          });
          // console.log(this.wizardSteps);
        } else {
          this.wizardSteps = this.wizardSteps[0];
        }
      } catch (error) {
        //
      }
    }
    this.$root.$on("openCamera", (obj) => {
      console.log(obj);
      var fileName =
        obj.item.item +
        "_" +
        parseInt(Math.random() * 1000).toString() +
        "_" +
        obj.item._id;
      that.photoProperties = {
        objectName: "shipment",
        recordId: obj.obj.parentObject._id,
        portal: "portal_" + this.$root.portal_id,
        filename: fileName,
        photoName: fileName,
        formModel: obj.item,
        childObject: "inventory\\" + obj.item._id,
        cameraWidth: this.$vuetify.breakpoint.lgAndUp
          ? 450
          : screen.availWidth - 50,
        cameraHeight: this.$vuetify.breakpoint.lgAndUp
          ? 337.5
          : screen.availHeight,
      };

      that.photoDialog = true;
    });
    this.$root.$on("rowAdded", (d) => {
      if (that._uid != that.$root.shipmentUid) {
        return;
      }

      //save inventory every time is added
      if (d.tbl.tableName == "inventory" && d.row && d.row.item) {
        var tableObject = d.tbl;
        that.inventoryTable = tableObject;
        that.inventoryTable.menuOpen = true;
        if (
          that.shipmentObject.model.estimate["non-binding"].shipment_service
            .length == 1
        ) {
          d.row.service_date =
            that.shipmentObject.model.estimate[
              "non-binding"
            ].shipment_service[0].service_date;
        } else {
          d.row.service_date = that.currentServceDate.value;
          //
        }
        if (that.model.stops) {
          var pickup = that.model.stops.find((s) => {
            return s.title.includes("pickup");
          });

          if (pickup) {
            d.row.from = pickup.full_address;
          }
          var dropoff = that.model.stops.find((s) => {
            return s.title.includes("dropoff");
          });
          if (dropoff) {
            d.row.to = dropoff.full_address;
          }
          if (that.model.has_storage) {
            d.row.to_storage = true;
          }
        }

        if (fun.deepFind(d, "rec.item.rec.item_handling")) {
          if (this.currentItemHandlingId == d.row._id) {
            return;
          }
          this.currentItemHandlingId = d.row._id;
          var handling = d.rec.item.rec.item_handling;
          // that.inventoryTable.menuOpen = false;
          if (handling.prompt && !tableObject.edited) {
            // console.log(handling.prompt);
            that.handlingPrompt = handling.prompt;
            that.itemDialog = !that.itemDialog;
            this.currentItem = d.row;
            // that.currentItem = obj.formModel;
            that.currentHandling = handling;
          }
          // } else {
        }
        if (d.row.item.startsWith("(CP) ")) {
          d.row.isMaterial = true;
        }
        that.submit(true, true);
        //
      }
    });
    this.$root.$on("itemsDeleted", (d) => {
      if (that._uid != that.$root.shipmentUid) {
        return;
      }

      if (d.tableName == "payment") {
        that.submit(true, true);
        //
      }
    });
    this.$root.$on("linkedObjectSelected", (d) => {
      var obj = fun.getParentByProperty(d.tbl, "shipment_id");
      if (
        obj &&
        that.$root.shipmentUid != obj._uid &&
        !that.linkedObjectSelected
      ) {
        return;
      }
      that.linkedObjectSelected = true;
      if (d.objectName == "v_customer_orders") {
        var data = {
          object_name: "customer",
          qry: {
            _id: d.data._id,
          },
        };
        axios
          .post(this.serverURL + "/get_data", data, {
            withCredentials: true,
          })
          .then((response) => {
            that.shipmentObject.model.customer = response.data.model[0];
            that.shipmentObject.model.customer.address = fun.removeDuplicates(
              that.shipmentObject.model.customer.address,
              "full_address"
            );
            that.shipmentObject.model.customer.address.forEach((a) => {
              a.use_existing = false;
            });
            that.shipmentObject.model.estimate[
              "non-binding"
            ].shipment_service[0].shipment_stop.forEach((a) => {
              // a.use_existing = true;
            });

            that.submit();
          });
      }
    });
  },
  beforeDestroy() {
    console.log("before destroy");
  },
  methods: {
    checkSlideGesture() {
      var that = this;
      if (window.safari) {
        history.pushState(null, null, location.href);
        window.onpopstate = function(event) {
          history.go(1);
        };
      }
      document.addEventListener("touchstart", handleTouchStart, false);
      document.addEventListener("touchmove", handleTouchMove, false);
      var touchstartX = 0;
      var touchendX = 0;
      function handleTouchStart(e) {
        // console.log("touch start");
        touchstartX = e.changedTouches[0].screenX;
      }
      function handleTouchMove(e) {
        // console.log("touch end");
        touchendX = e.changedTouches[0].screenX;
        handleGesture();
      }
      // document.addEventListener("DOMContentLoaded", function () {

      function handleGesture() {
        if (touchendX < touchstartX) {
          console.log("Swiped left");
          console.log(that.activeTabIndex);
          that.lastTab = that.activeTabIndex;
          // window.history.go(1);
        }
        if (touchendX > touchstartX) {
          console.log("Swiped right");
          console.log(that.activeTabIndex);
          that.lastTab = that.activeTabIndex;
          // window.history.go(1);
        }
      }
    },
    handleTouchStart(event) {
      // Your logic here to handle touch start
    },
    handleTouchMove(event) {
      event.preventDefault(); // Prevent moving to the first tab or other default actions
      // Additional logic to handle touch move, if necessary
    },
    assignCompany(location) {
      var employeeCompany = null;
      try {
        var companyZone = this.shipmentObject.additionalModel.zone.find((z) => {
          return z._id == location.carrier_zone.zone_id;
        });
        var currentEmployee = this.shipmentObject.additionalModel.employee[0];
        if (
          currentEmployee &&
          currentEmployee.company &&
          currentEmployee.company.length
        ) {
          employeeCompany = currentEmployee.company;
        }
        if (employeeCompany && employeeCompany.length == 1) {
          this.company = employeeCompany[0];
        } else {
          if (companyZone) {
            this.company = this.shipmentObject.additionalModel.company.find(
              (c) => {
                var zone = c.default_settings.zones.find((z) => {
                  return z._id == companyZone._id;
                });

                return zone;
              }
            );
          }
        }
        if (this.company) {
          this.shipmentObject.model.shipment_detail.company = {
            _id: this.company._id,
            company_name: this.company.company_name,
          };
          this.companyId = this.company._id;
        }
      } catch (error) {
        //
      }

      this.companyAssigned = true;
      // console.log(this.shipmentObject.additionalModel.company);
    },
    closeVisualInventory() {
      this.showVisualInventory = false;
    },
    initObject() {
      var that = this;

      this.topDrawer = this.$vuetify.breakpoint.mdAndUp ? 1 : 0;
      this.successMessage = "";
      if (!this.$root.reset) {
        this.$root.shipmentUid = this._uid;
      }
      this.$root.$on("mailSent", (d) => {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }

        that.model.crm.push({
          type: "letters",
          action_date_time: fun.formatDate(new Date(), false, true, true),
          letter_id: d.response._id,

          user: this.currentUser,
          description: d.response.letter_data.model.letter_name,
          time_stamp: fun.formatDate(new Date(), false, true, true),
        });
        that.submit(true, true);
        var curIndex = fun.clone(this.activeTabIndex);
        //d.response._id
        that.removeTab(curIndex - 1);

        that.activeTabIndex = 0; // curIndex - 1;
      });
      this.$root.reset = false;
      this.currentUser = this.$root.store.userData.email;

      this.refreshShipment();

      this.$root.$on("edited", (tbl) => {
        var obj = fun.getParentByProperty(tbl, "shipment_id");
        if (obj && this.$root.shipmentUid != obj._uid) {
          return;
        }
        // console.log(tbl);
        if (
          tbl.tableName == "inventory" &&
          that.$vuetify.breakpoint.smAndDown
        ) {
          that.mobileEdited = tbl.edited;
        }
      });

      this.$root.$on("tableFilterChanged", (tbl, keys) => {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        var items = that.getChargeList(tbl.filterItems[tbl.currentFilter]);
        this.$root.$emit("get_menu_items", { items: items });
      });
      this.$root.$on("tableChanged", (tbl, keys) => {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        // console.log(tbl);
        var obj = fun.getParentByProperty(tbl, "shipment_id");
        if (obj && this.$root.shipmentUid != obj._uid) {
          return;
        }

        switch (tbl.tableName) {
          case "inventory":
            that.calculateInventoryVolume();
            that.model.inventory = tbl.originalRecords;
            var totalVolume = that.model.volume ? that.model.volume : 0;
            tbl.tableHeader = "Tot. Volume: " + totalVolume;

            break;
          case "payment":
            that.model.payment = tbl.originalRecords;

            break;
          case "crm":
            that.model.crm = tbl.originalRecords;

            break;
          case "charges":
            that.currentModel.estimate_charges = tbl.originalRecords;

            that.calculateTotal(that.currentModel);

            break;
          default:
            break;
        }
      });
      this.$root.$on("achAuthorized", (tbl, keys) => {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }

        that.submit(true, true);
        // }
      });
      this.$root.$on("tableUpdated", (tbl, keys) => {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        if (tbl.tableName == "inventory") {
          // that.model.inventory = tbl.originalRecords;
          that.submit(true, true);
        }
        // console.log(tbl);
        if (tbl.tableName == "payment") {
          // that.model.inventory = tbl.originalRecords;
          that.submit();
        }
      });

      this.$root.$on("sms_sent", (resp) => {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        console.log(resp);
        try {
          var responseData = JSON.parse(resp.config.data);
          var message = responseData.message || responseData.body;

          if (
            message.startsWith(
              "Please Join Visual Inventory Session by clicking the link below"
            )
          ) {
            return;
          }
        } catch (error) {
          //
        }

        if ((resp.data && resp.data._id) || resp.data.id) {
          that.snackbarMessage = "Message Sent";
          that.snackbar = true;
          that.submit();
        }
        if (resp.data && resp.data.destination && resp.data.destination[0]) {
          this.errorMessage = resp.data.destination[0];
        }
      });
      // saveFunction;
      this.$root.$on("saveFunction", (t) => {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        if (t.tbl && t.tbl.k == "payment") {
          // console.log(t.item);
          that.chargeCard(t.item, t.editor);
        }
        if (t.function == "chargeCard" && t.obj) {
          console.log(t.item);
          if (
            that.model.payment.some((p) => {
              return p._id == t.model._id;
            })
          ) {
            that.chargeCard(t.model);
          }
        }
      });

      //tabAdded
      this.$root.$on("tabAdded", (t) => {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        if (
          t.shipment_id &&
          !this.activeTabIndex &&
          !this.activeTabIndex == 0
        ) {
          this.planReady = false;
          this.shipmentObject = null;
          this.dataTabs = [];
          this.activeTabIndex = 0;
          this.refreshShipment(true);
        }
      });
      this.$root.$on("fieldsRecalculated", (tbl, keys) => {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        var charges = tbl.table;
        var defaultCharges = that.shipmentObject.additionalModel.charge_list.filter(
          (c) => {
            return (
              c.charge_calculation && c.charge_calculation.is_default_charge
            );
          }
        );

        if (defaultCharges.length) {
          var percentCharges = defaultCharges.filter((c) => {
            return c.charge_calculation.percent_of;
          });

          if (percentCharges.length) {
            percentCharges.forEach((p) => {
              var parentCharge = charges.filter((c) => {
                return c.charge == p.charge_calculation.percent_of;
              })[0];
              if (parentCharge) {
                var percCharge = charges.filter((c) => {
                  return c.charge == p.charge_name;
                })[0];
                if (percCharge) {
                  percCharge.estimate_rate[0].rate = parentCharge.subtotal;
                }
              }
            });
          }
        }
      });
    },
    cancelWizard() {
      this.shipmentObject.model.no_wizard = true;
      this.wizardIndex = -1;
      this.saveButtonCaption = "Save Move Plan";
      this.saveButtonIcon = "mdi-check";
      this.activeTabIndex = 0;
      this.noWizard = true;
      this.submit(true, true);
    },
    updateStops() {
      if (!this.model.stops) {
        console.log("no stops");
        //
      }
    },
    checkPermissions() {
      var permittedActions = this.$root.store.permittedActions;

      if (permittedActions) {
        permittedActions.forEach((a) => {
          if (
            a.read_only_unassigned &&
            !this.$root.roles.some((role) => role.toLowerCase() === "admin") &&
            this.$root.user_id != this.model.shipment_detail.sales_person
          ) {
            this.readonly = true;
          }
          if (
            a.can_delete_payment ||
            this.$root.roles.some((role) => role.toLowerCase() === "admin")
          ) {
            this.canDeletePayment = true;
          }
        });
      }
    },
    applyHandling() {
      this.itemDialog = false;
      this.currentItem.handling = this.currentHandling;

      // this.tableKey = !this.tableKey;
      // this.updateHandling(true);
      this.applyInventoryHandling(this.currentItem, true);
      this.currentItemHandlingId = null;
      this.inventoryTable.table = this.model.inventory;
      this.submit(true, true);
      this.inventoryTable.scrollToEdited(this.currentItem);
      this.$root.$emit("keepMenu", "add_row");
      // this.inventoryTable.tableKey = !this.inventoryTable.tableKey;

      // this.inventoryTable.menuOpen = true;
    },
    changeTab(t) {
      this.mainTab = t;
    },
    invokeFn(fn, args) {
      return eval(this[fn](args));
    },
    getArgs(c) {
      var args = "";
      if (c.textArgs && eval(this[c.textArgs]).toString()) {
        args = this[c.textArgs];
      }
      return c.text + " " + args;
    },
    displayMenuItem(c) {
      return !c.if || eval(this[c.if]);
    },
    getVBindMenuItem(c) {
      return eval(this[c.vBind]);
    },
    getBankRoutingNumber(n) {
      axios
        .get("https://www.routingnumbers.info/api/data.json?rn=" + n)
        .then((response) => {
          console.log(response);
        });
    },
    getCompanyName() {
      if (this.shipmentObject.model.shipment_detail.company) {
        var companyName = this.shipmentObject.additionalModel.company.filter(
          (c) => {
            return (
              c._id == this.shipmentObject.model.shipment_detail.company ||
              c._id == this.shipmentObject.model.shipment_detail.company._id
            );
          }
        )[0].company_name;
        return companyName;
      }
    },
    chargeCard(item, editor) {
      var customer = this.model.customer;
      var address = customer.address[0].location.address;
      var geo = address.geo.location.address;
      var chargeData = {
        portal_id: this.$store.state.auth.portal.portal_id,
        company_id: this.company._id,
        provider_id: item.provider,
        payment: {
          card_number: item.card_number,
          card_expire: item.card_expire,
          cvv2: item.cvv2,
          amount: item.amount,
        },
        customer: {
          first_name: customer.contact.first_name,
          last_name: customer.contact.last_name,
          address: geo.street,
          apt: address.apt,
          city: geo.city,
          state: geo.stateCode,
          zip: geo.postalCode,
          country: geo.country,
          invoice_number: this.model.shipment_id,
        },
      };
      // this.$root.$emit("submitValidated", item);
      axios
        .post(this.serverURL + "/charge_card", chargeData)
        .then((response) => {
          console.log(response);
          if (response.data) {
            if (response.data.result_code.toLowerCase() != "error") {
              this.successMessage =
                "Card has been charged code:" + response.data.result_code;
              this.successMessageValue = true;
              this.$root.$emit("submitValidated", item);
              if (editor) {
                editor.save();
              }
            } else {
              this.errorMessage = response.data.message;
            }
          } else {
            this.errorMessage = response.data.message;
          }
        });
    },
    statusChanged(s) {
      if (s) {
        this.$root.$emit("timeLineUpdated", s);
        if (this.$refs.statusDialog) {
          this.$refs.statusDialog.isActive = false;
        }
      }
      this.model.shipment_detail.status_date_changed = fun.formatDate(
        "",
        false,
        true,
        true
      );
      this.createTasks();
    },
    createTasks() {
      if (this.shipmentObject.additionalModel.task) {
        var tasks = this.shipmentObject.additionalModel.task.filter((t) => {
          return (
            t.lead_status == this.model.shipment_detail.status &&
            t.service_type.includes(this.mainService.service_type) &&
            (t.progress_status == this.model.shipment_detail.progress_status ||
              !t.progress_status)
          );
        });
        if (tasks.length) {
          tasks.forEach((t) => {
            var dateTime = null;
            switch (t.date_type) {
              case "service_date":
                dateTime = new Date(this.mainService.service_date);
                break;
              case "booked_date":
                dateTime = new Date(this.mainService.booked_date);
                break;
              case "estimate_date":
                if (this.model.onsite_estimate.length) {
                  dateTime = new Date(
                    this.model.onsite_estimate[
                      this.model.onsite_estimate.length - 1
                    ].date_time
                  );
                }

                break;
              case "status_date_changed":
                dateTime = new Date(
                  this.model.shipment_detail.status_date_changed
                );
                break;
              default:
                break;
            }
            if (dateTime) {
              dateTime.addDays(parseInt(t.num_days));
            }

            if (t.action.includes("reminder")) {
              this.model.crm.push({
                type: "reminder",
                action_date_time: fun.formatDate(dateTime, false, true, true),
                addressed_to: t.coordinator,
                user: this.currentUser,
                description: t.task_description,
                time_stamp: fun.formatDate(new Date(), false, true, true),
              });
            }

            //
          });
        }
      }
    },
    uploadVideo(data) {
      var that = this;
      data.append("object_name", "shipment");
      data.append("record_id", this.model.shipment_id);
      data.append("dropbox", true);
      data.append(
        "portal",
        "portal_" + this.$store.state.auth.portal.portal_id
      );

      axios.post(this.serverURL + "/upload_file", data);
      that.successMessage =
        "Video has been sent to dropbox. It make take few minites to finish uploading";
    },
    updateObject(includeInitial) {
      if (
        (this._uid != this.$root.shipmentUid || includeInitial) &&
        this.$parent.$children.length > 1
      ) {
        this.$parent.$children.forEach((c) => {
          this.dataTabs = c.dataTabs;
          this.activeTabIndex = c.activeTabIndex;
        });
      }
    },
    calculateTotal(s) {
      var sum = 0;
      if (s.is_flat_rate && s.flat_rate) {
        s.total_estimate = parseFloat(s.flat_rate).toFixed(2);
      } else if (s.estimate_charges) {
        s.estimate_charges.forEach((item) => {
          sum += parseFloat(item.subtotal || 0);
        });
        s.total_estimate = sum.toFixed(2);
      }
    },
    addAllEvents() {
      var that = this;
      if (this.$vuetify.breakpoint.lgAndUp) {
        window.addEventListener(
          "resize",
          function(event) {
            that.movePlanKey = !that.movePlanKey;
          },
          true
        );
      }

      this.$root.$on("dataUnitValueClick", (obj) => {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        this.isClosing = false;
        // that.removeClosingTab(obj);
        var sPar = null;
        try {
          sPar = fun.findParent(obj.parent, "shipmentObject");
        } catch (error) {
          //
        }

        if (
          sPar &&
          parseInt(that.shipment_id) !=
            parseInt(sPar.shipmentObject.model.shipment_id)
        ) {
          return;
        }
        if (!that.model._id) {
          that.model._id = sPar.shipmentObject.model._id;
        }
        if (!that.model.shipment_id) {
          that.model.shipment_id = that.shipment_id;
        }
        that.addTab(obj);
        that.currentModel = that.getModel(obj);
        that.currentSchema = that.getSchema();
      });
      this.$root.$on("labelBtnChanged", (obj) => {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        if (obj.obj.addBtnTitle == "Add Room") {
          var tbl = fun.getParentByProperty(obj.obj, "table");
          var r = obj.itemValue;
          var e = tbl.filterItems.filter((t) => {
            return t.value == r;
          });
          if (e.length) {
            var n = e.length + 1;
            r = r + " " + n;
          }

          tbl.filterItems.push({
            caption: r,
            value: r,
            name: "room",
          });
          tbl.currentFilter = tbl.filterItems.length;
        }
        console.log(obj);
      });
      this.$root.$on("customBtnClick", (obj) => {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        if (obj.btn) {
          if (
            this.lastBtnClick &&
            this.lastBtnClick.btn == obj.btn &&
            this.lastBtnClick.id == obj.tbl._uid
          ) {
            return;
          }
          if (obj.tbl) {
            this.lastBtnClick = {
              btn: obj.btn,
              id: obj.tbl._uid,
            };
          }
          if (obj.btn == "customerProfile") {
            console.log(obj.frm.model._id);
            var item = {
              icon: "mdi-account",
              text:
                "Customer " +
                obj.frm.model.contact.first_name +
                " " +
                obj.frm.model.contact.last_name,

              link: "/customers/" + obj.frm.model._id,
              customer_id: obj.frm.model._id,

              permitted: true,
            };
            this.$root.addResentTab(item);
          }
        }

        if (
          that._uid == that.$root.shipmentUid &&
          that.$parent.$children.length > 1
        ) {
          var newComp = that.$parent.$children.filter((c) => {
            return c._uid != that.$root.shipmentUid;
          });
          newComp.forEach((c) => {
            if (c.shipmentObject) {
              c.shipmentObject.additionalModel.zone_rate = this.zoneRates;
              // this.updateZoneRates();

              c.zoneFrom = that.zoneFrom;
              c.zoneTo = that.zoneTo;
            }
          });
        }

        if (obj.id == "letters") {
          that.menuItemClick(obj);
        } else if (obj.id == "status") {
          that.model.shipment_detail.status = obj.item.value;
          this.submit(true, true);
          var curStatus = fun.capitalize(
            that.model.shipment_detail ? that.model.shipment_detail.status : ""
          );
          that.statusMenuBtn.color = that.getColor();
          that.statusMenuBtn.title = "Status: " + curStatus;
          that.sendToCallSystem(curStatus);
        } else if (obj.id == "addCojob") {
          obj = this.addCoJob(obj);

          this.addTab(obj);
          this.currentModel = this.getModel(obj);
          this.currentSchema = this.getSchema();
          that.movePlanKey = !that.movePlanKey;
          //
        } else if (obj.btn == "assignStorage") {
          console.log("assignStorage");
          var assignStorageCmb = obj.tbl.toolBarControls.find((c) => {
            return c.id == "storageList";
          });
          // assignStorageCmb.hidden = false;
          obj.tbl.toolBarKey = !obj.tbl.toolBarKey;
          obj.tbl.selected = [];
          obj.tbl.select = !obj.tbl.select;
          obj.tbl.closeMenuOnClick = !obj.tbl.closeMenuOnClick;
        } else if (obj.tbl) {
          switch (obj.tbl.tableName) {
            //menuItemClick
            case "payroll":
              //refresh_crew
              if (obj.btn == "refresh_crew") {
                // console.log("refresh crew");
                console.log(that.model);
                var itinerary = that.services[that.serviceIndex].itinerary;
                var payroll = that.services[that.serviceIndex].payroll;
                if (!payroll) {
                  payroll = [];
                }
                itinerary.forEach((i) => {
                  if (i.foreman) {
                    var exist = payroll.some((p) => {
                      return p.employee._id == i.foreman._id;
                    });
                    if (!exist) {
                      payroll.push({
                        _id: fun.guid(),
                        payroll_date: fun.formatDate(new Date()),
                        employee: {
                          _id: i.foreman._id,
                          full_name: i.foreman.full_name,
                        },
                        employee_role: "foreman",
                      });
                    }

                    if (i.foreman.crew && i.foreman.crew.crew_employee) {
                      i.foreman.crew.crew_employee.forEach((e) => {
                        exist = payroll.some((p) => {
                          return p.employee._id == e.employee._id;
                        });
                        if (!exist) {
                          payroll.push({
                            _id: fun.guid(),
                            payroll_date: fun.formatDate(new Date()),
                            employee: {
                              _id: e.employee._id,
                              full_name: e.employee.full_name,
                            },
                            employee_role: e.employee_role,
                          });
                        }
                      });
                    }
                  }
                });
              }
              if (obj.btn == "calc_payroll") {
                console.log("calculate payroll");
              }

              break;

            case "charges":
              if (obj.btn == "calc_charges") {
                var serviceId =
                  that.dataTabs[that.activeTabIndex - 1].obj.serviceId;
                var charges = that.calculateDefaultCharges(
                  obj.tbl.originalRecords
                  // that.currentModel.shipment_service.estimate_charges
                );

                var services =
                  that.model.estimate[that.getEstimateKey()].shipment_service;

                services.forEach((s) => {
                  if (s._id == serviceId) {
                    s.estimate_charges = charges;

                    var d = fun.mergeArrays(
                      s.estimate_charges,
                      obj.tbl.originalRecords
                    );
                  }
                  obj.tbl.editData = d;
                });

                // obj.tbl.refreshTable();

                that.formKey = !that.formKey;
                // that.submit(true, true);
              }
              break;
            case "inventory":
              if (
                obj.btn == "visual_inventory" &&
                that.$parent.$router.currentRoute.params.id == that.shipment_id
              ) {
                that.showVisualInventory = true; //!that.showVisualInventory;
              }

              if (obj.btn == "existing_inventory") {
                console.log(obj);
              }

              break;

            default:
              break;
          }
        }
      });
      this.$root.$on("comboUpdated", function(obj) {
        var parObj = fun.getParentByProperty(obj.obj, "shipment_id");
        var tableObject = fun.getParentByProperty(obj.obj, "table");
        if (parObj && that.$root.shipmentUid != parObj._uid) {
          return;
        }
        var curCharge;
        var charges;
        if (
          obj.model &&
          obj.ctlName == "all_location" &&
          that.addressUpdated != obj.model.value
        ) {
          // console.log(obj.model);
          if (obj.model) {
            if (obj.item && obj.item.warehouse_id) {
              that.model.has_storage = true;

              try {
                var warehouse = that.shipmentObject.additionalModel.warehouse.find(
                  (w) => {
                    return w._id == obj.item.warehouse_id;
                  }
                );
                if (warehouse) {
                  // newStop.geo = warehouse.geo;
                  obj.formModel.full_address = obj.item.value;
                  var location = that.getLocationFromWarehouse({
                    full_address: obj.item.value,
                  });
                  if (location) {
                    obj.formModel = {
                      address: location,
                    };
                  }

                  that.addNewStop(obj.model.value, true, obj.item.warehouse_id);
                  var addr = that.model.customer.address.filter((a) => {
                    return a._id == that.lastAddresId;
                  })[0];
                  if (addr) {
                    addr.full_address = obj.model.value;
                  }

                  obj.formModel.use_existing = false;

                  that.addressUpdated = obj.model.value;
                }
              } catch (error) {
                console.log(error);
              }
            } else {
              // console.log(obj.model);
              if (that.currentModel) {
                that.currentModel.address = that.shipmentObject.model.customer.address.find(
                  (a) => {
                    return a.full_address == obj.model.value;
                  }
                );
              }

              var shipment_stop = that.shipmentObject.model.estimate[
                that.getEstimateKey()
              ].shipment_service[that.serviceIndex].shipment_stop.find((s) => {
                return (
                  s.stop_number == that.activeTab.obj.stop_number ||
                  s.title == that.activeTab.obj.id
                );
              });
              if (shipment_stop) {
                shipment_stop.full_address = obj.model.value;
                shipment_stop.isWarehouse = false;
              }
              // console.log(that.currentModel);
            }
          }
        }

        switch (obj.objName) {
          case "service":
            that.currentServceDate = obj.model;
            break;
          case "charge_list":
            if (
              !obj.formModel.estimate_rate ||
              (obj.formModel.estimate_rate &&
                obj.formModel.estimate_rate.length &&
                !obj.formModel.estimate_rate[0].rate)
            ) {
              obj.formModel.estimate_rate = [];

              var chargeName = obj.model.item.value || obj.model.item;

              var chargeCategory = obj.model.item.rec
                ? obj.model.item.rec.charge_category
                : "";
              if (!chargeCategory && obj.model.first_option) {
                chargeCategory = obj.model.first_option.rec.charge_category;
              }
              if (!chargeCategory) {
                try {
                  chargeCategory = tableObject.filteredTabItems[
                    tableObject.currentFilter
                  ].caption.toLowerCase();
                } catch (error) {
                  //
                }
              }
              if (chargeCategory && chargeCategory != "material") {
                charges = that.getRate(
                  chargeName,
                  chargeCategory,
                  obj.formModel
                );
                obj.formModel.charge_category = chargeCategory;
                obj.formModel.charge = chargeName;
                if (charges.length) {
                  obj.formModel.estimate_rate = [];

                  charges.forEach((r) => {
                    obj.formModel.estimate_rate.push(r);
                  });
                } else {
                  var rate = 0;
                  var rateName = "";
                  if (
                    obj.model &&
                    obj.model.first_option &&
                    obj.model.first_option.rec
                  ) {
                    if (chargeCategory == "labor") {
                      try {
                        rate = obj.model.first_option.rec.labor_rate[0].rate;
                        rateName =
                          obj.model.first_option.rec.labor_rate[0]
                            .labor_rate_type;
                      } catch (error) {
                        //
                      }
                    }
                  }
                  obj.formModel.estimate_rate = [
                    {
                      rate_name: rateName,
                      rate: rate,
                      qty: 1,
                    },
                  ];
                }
              } else {
                var rec = obj.model.item.rec;
                if (!rec) {
                  rec = obj.model.first_option
                    ? obj.model.first_option.rec || { rate: 0, qty: 1 }
                    : { rate: 0, qty: 1 };
                }
                if (rec.labor_rate) {
                  obj.formModel.charge_category = "labor";
                  // obj.formModel.charge = chargeName;
                  // obj.formModel.description = "Labor Time";

                  if (obj.model) {
                    var laborRates = rec.labor_rate;
                    var estimateRate = [];
                    if (laborRates) {
                      // obj.formModel.estimate_rate = [];

                      laborRates.forEach((r, i) => {
                        estimateRate.push({
                          rate_name: r.labor_rate_type,
                          rate: obj.model.item.rec ? r.rate : 0,
                          qty: i ? 0 : 1,
                          unit: rec.unit,
                        });
                      });

                      obj.formModel.estimate_rate = estimateRate;
                    }
                  }
                } else {
                  obj.formModel.charge_category = "material";
                  obj.formModel.charge = chargeName;
                  obj.formModel.estimate_rate.push({
                    rate_name: "cont",
                    rate: obj.model.item.rec
                      ? obj.model.item.rec.container_price || 0
                      : 0,
                    qty: 1,
                    unit: "unit",
                  });
                  obj.formModel.estimate_rate.push({
                    rate_name: "pack",
                    rate: obj.model.item.rec
                      ? obj.model.item.rec.packing_price || 0
                      : 0,
                    qty: 1,
                    unit: "unit",
                  });
                  obj.formModel.estimate_rate.push({
                    rate_name: "unpack",
                    rate: obj.model.item.rec
                      ? obj.model.item.rec.unpacking_price || 0
                      : 0,
                    qty: 0,
                    unit: "unit",
                  });
                }
              }
            }
            if (tableObject) {
              tableObject.getCalculatedFields();
            }

            break;

          case "material_list":
            obj.formModel.estimate_rate = [];
            curCharge = that.shipmentObject.additionalModel.material_list.filter(
              (c) => {
                return c.material_name == obj.model;
              }
            );

            if (curCharge.length) {
              obj.formModel.estimate_rate.push({
                rate_name: "cont",
                rate: curCharge[0].container_price || 0,
                qty: 1,
                unit: "unit",
              });
              obj.formModel.estimate_rate.push({
                rate_name: "pack",
                rate: curCharge[0].packing_price || 0,
                qty: 1,
                unit: "unit",
              });
              obj.formModel.estimate_rate.push({
                rate_name: "unpack",
                rate: curCharge[0].unpacking_price || 0,
                qty: 0,
                unit: "unit",
              });
              tableObject.getCalculatedFields();
            }
            break;
          case "lead_status":
            if (
              that.originalModel.shipment_detail &&
              that.originalModel.shipment_detail.status != obj.model
            ) {
              that.statusChanged(obj.model);
            }
            break;
          default:
            break;
        }
        if (obj.ctlName == "storageList") {
          that.errorMessage = "";
          var inv = fun.getParentByProperty(obj.obj, "table");
          // console.log(inv.selected);
          // console.log(obj.model);
          if (!inv.selected.length && obj.model) {
            that.errorMessage = "Please select records to assign storage";
            return;
          }
          if (obj.model) {
            inv.selected.forEach((i) => {
              i.storage_id = obj.model.toString();
            });
            inv.closeMenuOnClick = true;
          }
        }
      });
      this.$root.$on("tableMounted", function(tbl) {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        var obj = fun.getParentByProperty(tbl, "shipment_id");
        if ((obj && this.$root.shipmentUid != obj._uid) || !obj) {
          return;
        }

        if (tbl.tableName == "inventory") {
          var totalVolume = that.model.volume ? that.model.volume : 0;
          tbl.tableHeader = "Total Volume: " + totalVolume;

          // tbl.toolBarControls[0].hidden = true;
          // that.shipmentObject.model.estimate[
          //   "non-binding"
          // ].shipment_service.forEach((s) => {
          //   tbl.toolBarControls[0]["v-bind"].items.push({
          //     text: s.service_type + " " + s.service_date,
          //     value: s.service_date,
          //   });
          // });
          // tbl.toolBarKey = !tbl.toolBarKey;
        }

        if (!that.objects.includes(tbl)) {
          that.objects.push(tbl);
        }
      });
      this.$root.$on("objAdded", function(obj) {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        if (obj.key == "address") {
          // console.log(obj);
        }
        if (obj.key === "shipment_service") {
          let model = that.data_object.model;
          let estimate = model.estimate[Object.keys(model.estimate)[0]];

          let shipment_service_schema = fun.getObjectsByKey(
            that.data_object.schema,
            "shipment_service"
          );
          shipment_service_schema.forEach((p) => {
            let services = p.properties;

            that.getCharges(
              services[obj.model.service_type],
              obj.model.service_type,
              estimate
            );
          });
        }
      });

      this.$root.$on("get_combo_items", function(combo) {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        if (combo.k == "estimate_address") {
          if (!combo.comboItems) {
            combo.comboItems = [];
          }
          var addresses = that.data_object.model.customer.address;
          addresses.forEach((a) => {
            var apt = "";
            if (!a.location) {
              a.location = {};
            }
            if (a.location.apt) {
              apt = " apt " + a.location.apt;
            }
            if (!a.location.address) {
              a.location.address = {};
            }
            var address = a.location.address.address + apt;
            if (address) {
              combo.comboItems.push(address);
            }
          });
        }

        if (combo.k == "tariff") {
          var model = that.data_object.model;

          var curTariff = that.data_object.all_tariff.filter(function(t) {
            if (t && t.haul_type) {
              return t.haul_type.includes(model.shipment_detail.haul_type);
            }
          });
          curTariff.forEach((tar) => {
            Object.keys(model.estimate).forEach(function() {
              var t = {
                text: tar.tariff_name,
                value: tar._id,
              };
              combo.comboItems.push(t);
            });
          });
        }

        if (combo.k == "company") {
          combo.comboItems = that.shipmentObject.additionalModel.company;
        }
      });
      this.$root.$on("valueChanged", function(obj) {
        // console.log(obj);
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        if (obj.key == "booked") {
          that.bookService(obj);
        }
      });

      this.$root.$on("addressLoaded", function(obj) {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        if (!that.data_object.model || !that.data_object.model.customer) {
          return;
        }
        var addresses = that.data_object.model.customer.address;

        addresses.forEach((a) => {
          var apt = "";
          if (!a.location) {
            a.location = {};
          }
          if (a.location.apt) {
            apt = " apt " + a.location.apt;
          }
          var label = a.address_type;
          if (!a.location.address) {
            a.location.address = {};
          }
          var address = a.location.address.address + apt;

          obj.comboItems = [];

          obj.comboItems.push({
            address: address,
            label: label,
            apt: a.location.apt,
            fullAddress: a.location.address.address,
          });
        });
        obj.defaultItems = fun.clone(obj.items);
      });
      this.$root.$on("addressChanged", function(addr, obj, oldAddress) {
        // that.updateObject(true);
        // console.log(obj.parModel);
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        if (!that.activeTab) {
          return;
        }
        var stopType = that.activeTab.tabTitle.toLowerCase();
        if (!stopType.includes("pickup") && !stopType.includes("dropoff")) {
          return;
        }

        var isInitial = that.$parent.$children.length > 1 ? 1 : 0;
        if (isInitial) {
          that.model = obj.parentModel;
        }
        if (addr.address == obj.parModel.full_address) {
          return;
        }
        var stops = fun.getObjects(
          obj.parentModel,
          "full_address",
          obj.parModel.full_address ||
            fun.deepFind(obj.parModel, "location.address.address")
        ); // find all addresses with this full_address
        var shipment_stop = obj.parentModel.estimate[
          that.getEstimateKey()
        ].shipment_service[that.serviceIndex].shipment_stop.filter((s) => {
          return s.value == stopType;
        });
        // if (shipment_stop.length) {
        //   shipment_stop[0].full_address = addr.address;
        // }
        stops = stops.concat(shipment_stop);
        // var stopType = that.dataTabs[
        //   that.activeTabIndex - 1
        // ].obj.title.toLowerCase();
        var filter = that.activeTab.filter;
        if (!filter) {
          return;
        }

        var addressType = filter.split("==")[1].replaceAll("'", "");

        if (
          addressType.indexOf("_" > -1) &&
          obj.parModel.full_address &&
          obj.parModel.full_address.indexOf(addressType) > -1
        ) {
          //empty address, change to actual address
          if (
            (stopType.includes("pickup") && !addressType.includes("origin")) ||
            (stopType.includes("dropoff") &&
              !addressType.includes("destination"))
          ) {
            that.getEstimate(that.model, that.serviceIndex);
            return;
          }
          stops
            .filter((s) => {
              return s.full_address == addressType;
            })
            .forEach((s) => {
              s.full_address = addr.address;
              if (s.address) {
                s.address = addr.address;
              }
            });
          obj.parModel.address = addr.address;
          obj.parModel.full_address = addr.address;
          obj.parModel.location = {
            address: addr,
          };
        } else {
          stops.forEach((s) => {
            if (s.value == stopType) {
              //shipment_stop
              s.full_address = addr.address;
            }
          });
          var newLocation = {
            full_address: addr.address,
            dwelling_type: obj.parModel.location
              ? obj.parModel.location.dwelling_type
              : "",
            apt: obj.parModel.location ? obj.parModel.location.apt : "",
            address: addr,
          };
          var newAddress = {
            full_address: addr.address,
            location: newLocation,
          };
          if (
            !obj.parentModel.customer.address.some((a) => {
              a.full_address == newAddress.full_address;
            })
          ) {
            obj.parentModel.customer.address.push(newAddress);
          }

          //add to customer address rather than change
        }
        if (stopType == "pickup" || stopType == "dropoff") {
          var zone = that.findZone(obj.parModel.location);
          if (stopType == "pickup") {
            that.zoneFrom = zone;
            that.assignCompany(obj.parModel.location);
          }
          if (stopType == "dropoff") {
            that.zoneTo = zone;
          }
        }
        if (!stops.length) {
          var stType = that.dataTabs[that.activeTabIndex - 1].obj.title;
          that.addNewStop(addr.address);
        }
        that.addressUpdated = addr.address;
        that.getEstimate(that.model, that.serviceIndex);
        that.movePlanKey = !that.movePlanKey;
        that.formkey = !that.formKey;
      });

      this.$root.$on("defaultAddressSelected", function(obj, addr) {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        var address = that.data_object.model.customer.address.filter((a) => {
          return a.address_type == addr.label;
        });
        var serviceStop = obj.parModel;
        if (address.length) {
          address = address[0];
          serviceStop.location = address.location;
          serviceStop.address_label = address.address_type;
        } else {
          console.log("new address");
        }
        this.$root.$emit("iteratorUpdated", serviceStop._id);
        this.$root.$emit("addressChanged", serviceStop._id);
      });
    },
    sendToCallSystem(status) {
      this.systemMessage = false;
      if (!this.model.customer["8x8_account_num"]) {
        return;
      }
      var data = {
        status: status,
        phone_number: this.model.customer.contact.phones.mobile.phone_number,
        account_num: this.model.customer["8x8_account_num"],
      };

      axios
        .post(this.serverURL + "/send_to_call_from_status", data, {
          withCredentials: true,
        })
        .then((response) => {
          console.log(response);
          if (response.data.error) {
            this.systemMessage = true;
            this.errorMessage =
              "Cannot send to campaign: " + response.data.error;
          } else if (response.data) {
            this.successMessage = "Sent to call campaign";
          }
        })
        .catch((reason) => {
          // console.log(reason);
        });
    },
    addNewStop(address, update, iswarehouse) {
      var stType = "Pickup";

      if (this.dataTabs.length > 0) {
        try {
          stType = this.dataTabs[
            this.activeTabIndex - 1
          ].obj.title.toLowerCase();
        } catch (error) {
          //
        }
      }
      var newStop = {
        full_address: address,
        value: stType,
        title: stType,
        text: stType.split("_")[0],
      };

      this.addStopToService(newStop, update);

      var addrFilter = "";
      if (
        this.dataTabs[this.activeTabIndex - 1] &&
        this.dataTabs[this.activeTabIndex - 1].obj
      ) {
        addrFilter = this.dataTabs[this.activeTabIndex - 1].obj.filter;
      } else {
        addrFilter = "r.full_address=='" + newStop.full_address;
      }

      // }
      if (this.dataTabs[this.activeTabIndex - 1]) {
        if (!iswarehouse) {
          var curAddress = this.model.customer.address.find((r) => {
            return eval(addrFilter);
          });
          if (curAddress) {
            curAddress.full_address = address;
          }
        }
      }

      return stType;
    },
    deleteUnit(obj, index) {
      console.log(obj, index);
      var model = this.shipmentObject.model;
      var estimateKey = Object.keys(model.estimate)[0];
      this.$root.$confirm
        .open("Delete", "Confirm deleting " + obj.title + " ?", {
          color: "red",
        })
        .then((confirm) => {
          if (confirm) {
            switch (obj.objectName) {
              case "shipment_service":
                var services = model.estimate[estimateKey].shipment_service;
                services.splice(index, 1);
                break;
              case "address":
                var addresses =
                  model.estimate[estimateKey].shipment_service[0].shipment_stop;

                model.estimate[
                  estimateKey
                ].shipment_service[0].shipment_stop = addresses.filter((a) => {
                  var stopNumber = parseInt(obj.stopN) + 1;
                  return a.value != obj.obj + "_" + stopNumber;
                });

                break;
              default:
                break;
            }
            this.submit(true, true);
            this.movePlanKey = !this.movePlanKey;
          }
        });
    },
    calculateDefaultCharges(r) {
      var that = this;
      var serviceType = this.services[this.serviceIndex].service_type;
      var getSubtotal = function(c) {
        var m = 0;
        c.estimate_rate.forEach((s) => {
          m += (s.rate || 0) * (s.qty || 0);
        });
        m = m.toFixed(2);
        return m;
      };
      var createCharge = function(p) {
        var rates = that.getRate(p.charge_name, p.charge_category);
        if (rates.length) {
          if (
            !r.some((e) => {
              return (
                e.charge == p.charge_name &&
                e.charge_category == p.charge_category
              );
            })
          ) {
            var estCharge = {
              _id: fun.guid(),
              charge: p.charge_name,
              charge_category: p.charge_category,
              subtotal: 0,
              estimate_rate: [],
            };
            rates.forEach((r) => {
              estCharge.estimate_rate.push(r);
            });
            estCharge.subtotal = getSubtotal(estCharge);
            estimateCharges.push(estCharge);
          }
        }
      };

      var estimateCharges = this.mainService.estimate_charges || [];
      var charges = [];
      var defaultCharges = this.shipmentObject.additionalModel.charge_list.filter(
        (c) => {
          return (
            ((!c.service_type ||
              !c.service_type.length ||
              c.service_type.includes(serviceType)) &&
              c.charge_calculation &&
              c.charge_calculation.is_default_charge) ||
            ((!c.service_type || c.service_type.includes(serviceType)) &&
              c.always_apply)
          );
        }
      );

      var companyIncluded = function(c) {
        if (!c.company) {
          return true;
        } else {
          if (c.company && c.company.length) {
            var include = false;
            c.company.forEach((comp) => {
              if (!comp.collection || comp.collection == "company") {
                if (
                  comp._id ==
                  that.shipmentObject.model.shipment_detail.company._id
                ) {
                  include = true;
                }
              } else {
                var service = that.services[that.serviceIndex];
                if (
                  (comp.collection == "agent" &&
                    service.agent &&
                    service.agent._id == comp._id) ||
                  (comp.collection == "broker" &&
                    service.comp.collection == "agent" &&
                    service.agent &&
                    service.comp.collection == "agent" &&
                    service.agent &&
                    (service.agent._id == comp._id._id) == comp._id &&
                    service.agent._id == comp._id)
                ) {
                  include = true;
                }
              }
            });
            return include;
          }
        }
      };
      defaultCharges = defaultCharges.filter((c) => {
        return companyIncluded(c);
      });

      if (defaultCharges.length) {
        //remove old charges
        if (estimateCharges && estimateCharges.length) {
          defaultCharges.forEach((c) => {
            var chargeExist = estimateCharges.filter((e) => {
              return (
                e.charge == c.charge_name &&
                e.charge_category == e.charge_category
              );
            });

            // }
            if (chargeExist.length) {
              estimateCharges.splice(
                estimateCharges.indexOf(chargeExist[0]),
                1
              );
              var existChargeId = chargeExist[0]._id;
              var index = fun.getArrayElementIndexById(r, existChargeId);
              r.splice(index, 1);
            }
          });
        }

        var laborCharges = defaultCharges.filter((c) => {
          return c.charge_category == "labor";
        });
        if (laborCharges.length) {
          laborCharges.forEach((c) => {
            var laborRate = this.calculateLabor(c);
            var laborRateType = laborRate.rate[0];

            var lab = [];
            estimateCharges = estimateCharges.filter((e) => {
              return e.charge != laborRate.rate_name;
            });
            laborRate.qty.forEach((q) => {
              var description = fun.capitalize(q.rate_name);

              var estimateRate = [];

              laborRate.rate.forEach((r, i) => {
                estimateRate.push({
                  rate_name: r.labor_rate_type,
                  rate: r.rate,
                  qty: !i ? q.qty : 0,
                  unit: laborRate.unit,
                });
              });

              estimateCharges.push({
                _id: fun.guid(),
                charge_category: "labor",
                description: description,
                charge: laborRate.rate_name,
                // labor_rate_type: laborRateType.labor_rate_type,
                estimate_rate: estimateRate,
                subtotal: (laborRateType.rate * q.qty).toFixed(2),
              });
            });
          });
        }
        var perUnitCharges = defaultCharges.filter((c) => {
          var isPerUnitRate;
          if (c.rates && c.rates.length) {
            c.rates.forEach((r) => {
              if (r.unit && r.rate) {
                isPerUnitRate = true;
              }
            });
          }

          return isPerUnitRate;
        });
        if (perUnitCharges.length) {
          perUnitCharges.forEach((p) => {
            createCharge(p);
          });
        }

        var parentCharges = defaultCharges.filter((c) => {
          return (
            c.charge_calculation &&
            c.charge_calculation.is_default_charge &&
            !c.charge_calculation.percent_of
          );
        });

        var percentCharges = defaultCharges.filter((c) => {
          return c.charge_calculation && c.charge_calculation.percentage;
        });
        if (parentCharges.length) {
          parentCharges.forEach((p) => {
            createCharge(p);
          });
        }
        if (percentCharges.length) {
          percentCharges.forEach((p) => {
            createCharge(p);
          });
        }
      }

      return estimateCharges;
    },
    getStopLocation(s) {
      return this.model.customer.address.find((a) => {
        return a.full_address == s.full_address;
      });
    },
    calculateLabor(c) {
      // console.log(charges);
      var service = this.services[this.serviceIndex];
      var w =
        this.model.volume || this.model.weight
          ? this.model.weight || this.model.volume * 7
          : 0;
      var stairs = 0;

      service.shipment_stop.forEach((s) => {
        var location = null;

        try {
          location = this.getStopLocation(s).location;
        } catch (error) {
          //
        }
        var l = location;
        if (l && l.flight_of_stairs) {
          stairs += parseInt(l.flight_of_stairs);
        }
      });
      // charges.forEach((c) => {
      var crew = c.crew_rate.filter((r) => {
        return (
          (parseFloat(r.max_weight) >= w && !r.max_stairs) ||
          (parseFloat(r.max_weight) >= w && parseInt(r.max_stairs) >= stairs)
        );
        // });
      });

      try {
        fun.sortObjects(crew, "num_men");
      } catch (error) {
        //
      }
      var hrs = 0;
      var rate = 0;
      var unit = "hrs";
      var rate_name = "";

      if (crew[0]) {
        rate = crew[0].labor_rate;
        unit = crew[0].unit;
        hrs = this.calculateHours(crew[0], service, c);
        rate_name = crew[0].num_men + " men " + crew[0].num_truck + " truck";
        service.resources = [];
        service.resources.push({
          resource_type: "men",
          qty: crew[0].num_men,
        });
        service.resources.push({
          resource_type: "truck",
          qty: crew[0].num_truck,
        });
      }

      return {
        rate_name: rate_name,
        rate: rate,
        qty: hrs,
        unit: unit,
      };
    },
    calculateHours(crew, service, defaultSettings) {
      // var defaultSettings = this.company.default_settings;
      var eff_factor = parseFloat(defaultSettings.eff_factor) || 45;
      // var l = filtered[0];
      var totalStairs = 0;
      var totalCarry = 0;
      var elevator = false;
      service.shipment_stop.forEach((s) => {
        var addr = this.model.customer.address.find((a) => {
          return a.full_address == s.full_address;
        });
        if (addr) {
          var loc = addr.location;
          if (loc.flight_of_stairs) {
            totalStairs += parseInt(loc.flight_of_stairs);
          }
          if (loc.long_carry) {
            totalCarry += parseInt(loc.long_carry);
          }
          if (loc.elevator) {
            elevator = true;
          }
        }
      });

      eff_factor *= Math.pow(defaultSettings.stairs_factor || 0.9, totalStairs); // Decrease efficiency per flight of stairs
      eff_factor *= Math.pow(
        defaultSettings.long_carry_factor || 0.95,
        totalCarry / 50
      ); // Decrease for long carry, per 50 feet

      if (elevator) {
        eff_factor *= defaultSettings.elevator_factor || 0.8; // Further reduce efficiency if an elevator is used
      }

      var job_hours =
        Math.floor(this.model.volume || 0) / eff_factor / crew.num_men;
      job_hours = Math.round(job_hours, 0);
      var travel_hours = 0;
      var distance = service.distance;
      if (distance) {
        var mileage = (distance / 1000 / 1.6).toFixed(2);
        var truck_speed = parseInt(defaultSettings.truck_speed);
        travel_hours = (mileage / (truck_speed || 50)).toFixed(1) || 0;
        travel_hours = Math.round(travel_hours, 1);
        // job_hours += travel_hours;
      }
      if (parseFloat(defaultSettings.min_hrs) > parseFloat(job_hours)) {
        job_hours = defaultSettings.min_hrs;
      }
      if (parseFloat(defaultSettings.travel_time) > parseFloat(travel_hours)) {
        travel_hours = defaultSettings.travel_time;
      }
      // (parseFloat(job_hours) + parseFloat(travel_hours)).toFixed(2);
      var rates = [
        { rate_name: "labor_time", qty: parseFloat(job_hours).toFixed(2) },
        { rate_name: "travel_time", qty: parseFloat(travel_hours).toFixed(2) },
      ];
      return rates;
    },
    getRate(chargeName, chargeCategory, rec) {
      var charges = [];

      var curCharge = this.shipmentObject.additionalModel.charge_list.filter(
        (c) => {
          return (
            c.charge_category == chargeCategory && c.charge_name == chargeName
          );
        }
      );
      if (curCharge.length) {
        if (curCharge[0].rates && !curCharge[0].charge_calculation) {
          curCharge[0].rates.forEach((r) => {
            charges.push({
              rate_name: r.rate_name,
              rate: r.rate || 0,
              qty: 1,
              unit: r.unit,
            });
          });
        }
        if (curCharge[0].charge_calculation) {
          charges = [];
          var res;
          var calc = curCharge[0].charge_calculation;
          if (calc.special_function) {
            if (this[calc.special_function]) {
              res = eval(this[calc.special_function](calc, curCharge[0], rec));
              if (!calc.file_name) {
                //async calculation
                if (res) {
                  charges.push({
                    rate_name: "rate",
                    rate: res.rate,
                    qty: res.qty,
                    unit: res.unit,
                  });
                }
              }
            }
          } else {
            if (
              calc.percent_of &&
              calc.percentage &&
              this.mainService.estimate_charges
            ) {
              var percCharge = this.mainService.estimate_charges.filter((c) => {
                return c.charge == calc.percent_of;
              })[0];
              if (percCharge) {
                res = (percCharge.subtotal * calc.percentage) / 100;
                charges.push({
                  rate_name: "rate",
                  rate: percCharge.subtotal,
                  qty: calc.percentage / 100,
                  unit: "unit",
                });
              }
            } else if (curCharge[0].rates) {
              curCharge[0].rates.forEach((r) => {
                var qty = 0;
                if (!r.unit) {
                  qty = 1;
                }
                if (this.perUnits[r.unit]) {
                  qty = this.currentModel.shipment_service[
                    this.perUnits[r.unit]
                  ];
                }
                var subtotal = [r.rate || 0] * qty;
                if (subtotal) {
                  charges.push({
                    rate_name: r.rate_name,
                    rate: r.rate || 0,
                    qty: qty,
                    unit: r.unit,
                    subtotal: subtotal.toFixed(2),
                  });
                }
              });
            }
          }
        }
      }
      return charges;
    },
    getAddCF() {
      var formula = "f.room=='Add Items'?f.volume*f.qty:0";
      return fun.sum(this.shipmentObject.model.inventory, formula);
    },
    additional_cu_ft() {
      var addCuFt = this.getAddCF();
      if (addCuFt && this.currentModel.shipment_service.rate) {
        var rate = {
          unit: "cu_ft",
          qty: addCuFt,
          rate: parseFloat(this.currentModel.shipment_service.rate),
        };
        return rate;
      }
    },

    //{"charge_calculation.special_function": { $exists: true, $ne: "" }}
    getDistanceTariff(data, charge, rec) {
      axios
        .post(this.serverURL + "/get_distance_tariff", data, {
          withCredentials: false,
        })
        .then((response) => {
          var rate = response.data;
          // console.log(response.data);
          var estimateRate = [];
          estimateRate.push({
            rate_name: "rate",
            rate: rate,
            qty: 1,
            // unit: res.unit,
          });
          if (rec) {
            rec.estimate_rate = estimateRate;
          } else {
            var estimateCharges = this.mainService.estimate_charges || [];

            estimateCharges.push({
              charge_category: charge.charge_category,
              charge: charge.charge_name,
              estimate_rate: estimateRate,
              subtotal: rate.toFixed(2),
            });
            this.formKey = !this.formKey;
          }

          // }
          //
        });
    },
    calculate_stg(r, charge, rec) {
      // console.log("Calculate Tariff", r);
      var service = this.services[this.serviceIndex];
      // + "\\" + r.file_name.name
      var data = {
        excel_file: r.file_name.dir,
        miles: service.mileage,
        weight: service.job_weight,
      };
      this.getDistanceTariff(data, charge, rec);
    },
    calculate_by_distance_weight(r, charge, rec) {
      // console.log("Calculate Tariff", r);
      var service = this.services[this.serviceIndex];
      // + "\\" + r.file_name.name
      // var path = fun.getServerURL()=="http://127.0.0.1:5000"?;

      var data = {
        excel_file: r.file_name.dir,
        miles: service.mileage,
        weight: service.job_weight,
      };
      this.getDistanceTariff(data, charge, rec);
    },
    calculate_by_zone() {
      if (!this.zoneRates || !this.zoneRates.length) {
        return 0;
      }
      // this.updateZoneRates();
      if (this.getAddCF()) {
        return 0;
      }

      var volume = this.model.volume || 0;
      fun.sortObjects(this.zoneRates, "min_size");
      if (parseFloat(this.zoneRates[0].min_size) > parseFloat(volume)) {
        this.model.volume = parseFloat(this.zoneRates[0].min_size);
        volume = this.model.volume;
      }
      this.zoneRates = this.zoneRates.filter((f) => {
        return parseFloat(f.min_size) <= parseFloat(volume);
      });
      // this.zoneRates = this.zoneRates.sort(function(a, b) {
      //   return parseFloat(b.min_size) < parseFloat(a.min_size);
      // });
      fun.sortObjects(this.zoneRates, "min_size", true);
      var zoneRate = this.zoneRates[0];
      this.currentModel.shipment_service.rate = zoneRate.rate;
      this.currentModel.shipment_service.loadboard_price =
        zoneRate.loadboard_rate;
      var rate = {
        unit: "cu_ft",
      };
      if (zoneRate) {
        if (
          parseFloat(zoneRate.rate) * volume <
          parseFloat(zoneRate.min_price)
        ) {
          rate.rate = parseFloat(zoneRate.min_price);
          rate.qty = 1;
        } else {
          rate.rate = parseFloat(zoneRate.rate);
          rate.qty = volume;
        }
      }
      return rate;
    },
    showTab(name) {
      var obj = {};
      if (typeof name === "object") {
        if (Object.keys(name)[0] == "storage_id") {
          //
        }
      }
      switch (name) {
        case "payment":
          obj = {
            obj: "payment",
            objectName: "payment",
            title: "Payments",
          };
          break;
        case "shipment_detail":
          obj = {
            obj: "shipment_detail",
            objectName: "shipment_detail",
            title: "Order Details",
          };
          break;
        case "crm":
          obj = {
            obj: "crm",
            objectName: "crm",
            title: "CRM",
          };
          break;
        case "attachments":
          obj = {
            obj: "attachments",
            objectName: "attachments",
            title: "Attachments",
          };
          break;

        case "inventory":
          obj = {
            obj: "inventory",
            objectName: "inventory",
            title: "Inventory",
          };
          break;
        case "onsite_estimate":
          obj = {
            obj: "onsite_estimate",
            objectName: "onsite_estimate",
            title: "Onsite Estimate",
          };
          break;
      }
      this.addTab(obj);
      this.currentModel = this.getModel(obj);

      this.currentSchema = this.getSchema();
    },
    removeClosingTab() {
      // if (!this.isClosing) {
      //   console.log(this.dataTabs);
      var close = -1;
      this.dataTabs.forEach((t, i) => {
        if (t.obj.title == "Job Closing") {
          close = i;
        }
      });
      if (close > -1) {
        this.removeTab(close);
      }
      //
      // }
    },
    addTab(obj) {
      if (!obj) {
        obj = {};
      }
      // console.log(this._uid);
      this.lastTab = null;
      this.childEdited = false;
      var that = this;

      if (
        obj &&
        obj.objectName == "shipment_service" &&
        this.shipmentObject &&
        this.shipmentObject.model.document
      ) {
        this.shipmentObject.model.document.filter((r) => {
          var included = false;
          if (!r.service_type || typeof r.service_type == "string") {
            included = true;
          } else {
            if (r.service_type.length) {
              r.service_type.forEach((s) => {
                if (s._id == obj.serviceId) {
                  included = true;
                }
              });
            }
          }

          return included;
        });
      }

      if (obj && obj.obj == "payment") {
        this.shipmentObject.schema.properties.payment["v-bind"].noDelete = !this
          .canDeletePayment;
      }

      var tabTitle = "";
      if (obj) {
        tabTitle = fun.capitalize(obj.title).toUpperCase();
        if (obj && obj.id == "storage") {
          if (obj.value) {
            this.showStorage(obj);
            return;
          } else {
            tabTitle = "New Storage";
          }
        }
      }

      var tabExist =
        that.dataTabs &&
        that.dataTabs.filter((t) => {
          return t.tabTitle == tabTitle;
        });

      if (this.readOnlyObj.indexOf(obj.obj) != -1) {
        return;
      }

      if (tabExist && !tabExist.length) {
        this.isLetter = null;
        this.isPayment = null;
        var caption = this.$route.params.id == "0" ? "Create" : "Save";
        this.saveButtonCaption = caption + " Move Plan";
        if (obj.isLetter) {
          this.isLetter = true;
          this.letterContainer(obj);
        }
        if (obj.obj == "payment") {
          this.isPayment = true;
          this.saveButtonCaption = "Apply Payment";
        }

        that.dataTabs.push({
          tabTitle: tabTitle,
          tabId: obj.objectName || obj.id,
          filter: obj.filter,
          parentObject: obj.parentObject,
          letterBind: obj.letterBind,
          obj: obj,
          icon: obj.isLetter ? "mdi-email" : "mdi-" + obj.icon,
        });
        that.loadedObjects.push(obj);
        that.formKey = !that.formkey;
        that.activeTabIndex = that.dataTabs.length;

        that.activeTab = that.dataTabs[that.activeTabIndex - 1];
      } else {
        that.activeTabIndex = that.dataTabs.indexOf(tabExist[0]) + 1;
        that.activeTab = that.dataTabs[that.activeTabIndex - 1];
      }

      this.formKey = !this.formKey;
    },
    showStorage(obj) {
      obj.icon = "key";
      var item = {
        icon: obj.icon,
        text: "Storage #" + obj.value,
        storage_id: obj.value,
        link: "/storage/" + obj.value,

        permitted: true,
      };
      this.$root.addResentTab(item);
    },
    menuItemClick(m, d, item) {
      var that = this;
      // console.log(m);
      this.isClosing = false;
      var obj = {};
      if (m == "closing") {
        obj = {
          id: "shipment_service",
          title: "Job Closing",
          objectName: "shipment_service",
        };
        this.isClosing = true;
        if (this.dataTabs.length) {
          this.dataTabs.splice(0, this.dataTabs.length);
          this.menuItemClick("closing");
        }
      }
      if (m == "pickup" || m == "dropoff") {
        obj = this.addExtraStop(m, d);
      }

      if (m == "storage") {
        obj = { id: "storage" };
      }
      if (m.objectName && m.objectName == "service_type") {
        obj = this.addCoJob(m);
      }
      if (m.id && m.id == "letters") {
        obj.isLetter = true;
        obj.title = m.item.text;
        obj.obj = m;
      }

      this.addTab(obj);
      this.currentModel = this.getModel(obj);

      that.currentSchema = this.getSchema();
    },
    formatStopValue(l) {
      var lab = l[0];
      var n = l[1];
      var label = lab
        .replace("origin", "pickup")
        .replace("destination", "dropoff");
      if (n && n != "address") {
        n = parseInt(n) + 1;
        label += "_" + n;
      }
      return label;
    },
    formatStops(stops) {
      this.shipmentObject.model.customer.address.forEach((a) => {
        a.use_existing = false;
      });

      if (!stops) {
        stops = [];
      }
      if (!stops.length) {
        this.shipmentObject.model.customer.address.forEach((a) => {
          var l;
          var text;

          if (a.address_type) {
            l = a.address_type.split("_");
          } else {
            if (a.full_address.indexOf("_") != -1) {
              l = a.full_address.split("_");
            }
          }
          if (l) {
            text = this.formatStopValue(l);
            stops.push({
              full_address: a.full_address,
              value: text,
              text: text,
              stop_number: text == "pickup" ? "1" : "2",
            });
          } else {
            if (this.$root.customerId && !stops.length) {
              stops.push({
                full_address: "origin_address",
                value: "pickup",
                text: "pickup",
                stop_number: "1",
              });
              stops.push({
                full_address: "destination_address",
                value: "dropoff",
                text: "dropoff",
                stop_number: "2",
              });
            } else {
              return [];
            }
          }
        });
      } else {
        var newStops = [];
        stops.forEach((st) => {
          if (!st.value) {
            var address_label = "";
            if (st.address_label) {
              // if (st.address_label) {
              address_label = st.address_label;
              // }
            } else {
              address_label = st.stop_type; // fun.deepFind(st, "address.address");
            }

            var s = {
              value: address_label,
              address_label: address_label,
              text: this.formatStopValue(address_label.split("_")),
              stop_number: st.stop_number,
            };
            newStops.push(s);
          }
        });
        if (newStops.length) {
          stops = newStops;
        }
      }
      return stops;
    },
    getServices() {
      var model = this.shipmentObject.model;
      var estimateKey = Object.keys(model.estimate)[0];

      this.services = model.estimate[estimateKey].shipment_service;
    },
    addCoJob(m) {
      var id = fun.guid();
      var model = this.shipmentObject.model;
      var estimateKey = Object.keys(model.estimate)[0];
      var stops = [];
      var serviceType = this.shipmentObject.additionalModel.service_type.find(
        (t) => {
          return t.service_type == m.item.value;
        }
      );

      stops = this.mainService.shipment_stop.filter(
        (stop) =>
          serviceType.stop_type && serviceType.stop_type.includes(stop.value)
      );
      model.estimate[estimateKey].shipment_service.push({
        service_type: m.item.value,
        _id: id,
        shipment_stop: stops,
      });
      this.services = model.estimate[estimateKey].shipment_service;
      var obj = {
        filter: "r._id=='" + id + "'",
        objectName: "shipment_service",
        title: m.item.text,
        serviceId: id,
        obj: "services",
        // shipment_stop: stop,
      };

      return obj;
    },
    addExtraStop(type, stopLength) {
      var data = this.getModel({
        objectName: "address",
      });
      var id = fun.guid();
      this.lastAddresId = id;

      var obj = {
        _id: id,
        location: {
          address: {
            geo: {
              address: {},
            },
          },
        },
      };
      var locationType =
        type == "pickup" ? "origin" + stopLength : "destination" + stopLength;
      var stN = stopLength + 1;
      var title = type == "pickup" ? "pickup_" + stN : "dropoff_" + stN;
      var full_address = locationType + "_address";
      obj.full_address = full_address;
      data.address = this.shipmentObject.model.customer.address;
      data.address.push(obj);
      var st = {
        title: title,
        value: title,
        full_address: full_address,
        stop_number: stN,
        text: type,
      };
      this.addStopToService(st);
      var returnObj = {
        filter: "r.full_address=='" + obj.full_address + "'",
        objectName: "address",
        title: title,
        canDelete: true,
      };
      // this.submit(true, true);
      return returnObj;
    },
    addStopToService(st, update) {
      var model = this.shipmentObject.model;
      if (model.stops) {
        var obj =
          this.activeTab && this.activeTab.obj ? this.activeTab.obj : st;
        var stopN = obj.stop_number || st.stop_number;
        var sStop = model.stops.find((s) => {
          return (
            s.stop_number == stopN && s.value == obj.value
            //  &&
            // s.full_address == st.value.toLowerCase()
          );
        });
        if (sStop) {
          sStop.full_address = st.full_address;
        } else {
          model.stops.push(st);
        }
        Object.keys(model.estimate).forEach((k) => {
          var services = model.estimate[k].shipment_service;
          services.forEach((s) => {
            if (!update) {
              this.getStopNumber(s.shipment_stop, st);

              s.shipment_stop.push(st);
            } else {
              var myStop = s.shipment_stop.find((s) => {
                return (
                  s.value.toLowerCase() == st.value.toLowerCase()
                  //  &&
                  // s.full_address == st.value.toLowerCase()
                );
              });
              if (myStop) {
                myStop.full_address = st.full_address;
              }
            }
          });
        });
      }
    },
    getStopNumber(stops, st) {
      var t = st.value.includes("pickup") ? "pickup" : "dropoff";
      var stN = 0;
      stops.forEach((s) => {
        if (s.value.includes(t)) {
          s.stop_number = parseInt(s.stop_number);
          if (parseInt(s.stop_number) > stN) {
            stN = parseInt(s.stop_number);
          }
        }
      });
      st.stop_number = stN + 1;
    },
    findZone(addr) {
      var geo = fun.deepFind(addr, "geo");
      if (!geo && addr && addr.address) {
        geo = addr.address.geo;
      }
      if (!geo) {
        return "";
      }
      var location = geo.location.address || geo.location;
      var zone = this.shipmentObject.additionalModel.zone;
      var elementInArray = function(array, el) {
        if (!el) return false;
        if (!Array.isArray(array)) {
          array = array.split(",");
        }
        const index = array.findIndex((element) => {
          return (
            !element ||
            element.toString().toLowerCase() === el.toString().toLowerCase()
          );
        });
        return index != -1;
      };

      var myZones = zone.filter((z) => {
        if (z.states) {
          return elementInArray(z.states, location.stateCode);
        }
        if (z.locations) {
          return elementInArray(z.locations, location.stateCode);
        }
      });
      if (myZones.length) {
        myZones = myZones.filter((z) => {
          return (
            !z.counties ||
            !z.counties.length ||
            elementInArray(z.counties, location.county)
          );
        });
      }
      if (myZones.length) {
        myZones = myZones.filter((z) => {
          return (
            !z.cities ||
            !z.cities.length ||
            elementInArray(z.cities, location.city)
          );
        });
      }
      // console.log(myZones);
      if (myZones.length) {
        myZones.forEach((z) => {
          if (z.type == "tariff_zone") {
            addr.zone = {
              zone_name: z.zone_name,
              zone_id: z._id,
            };
          }
          if (z.type == "carrier_zone") {
            addr.carrier_zone = {
              zone_name: z.zone_name,
              zone_id: z._id,
            };
          }
        });

        this.movePlanKey = !this.movePlanKey;
        if (addr.zone) {
          return addr.zone.zone_id;
        }
      }
    },
    addMissingStops(addresses, shipmentStops) {
      // console.log(this.shipmentObject.model.stops);
      var myStop = this.shipmentObject.model.stops[0];
      var stopAddress = myStop.full_address;
      var missingAddress = addresses.find((a) => {
        return a.full_address != stopAddress;
      });
      if (missingAddress) {
        var stopType = myStop.value == "pickup" ? "dropoff" : "pickup";
        var stopNumber = myStop.stop_number == "1" ? "2" : "1";
        this.shipmentObject.model.stops.push({
          stop_number: stopNumber,

          text: stopType,
          value: stopType,
          full_address: missingAddress.full_address,
          title: stopType,
        });
        shipmentStops = this.shipmentObject.model.stops;
      }
    },
    parseAddresses() {
      var addresses = this.shipmentObject.model.customer.address;
      var shipmentStops = this.shipmentObject.model.estimate[
        this.getEstimateKey()
      ].shipment_service[this.serviceIndex].shipment_stop;
      addresses.forEach((a) => {
        if (a.location && a.location.address && a.location.address.address) {
          if (
            (a.location.address.geo &&
              a.location.address.geo.location.position) ||
            a.location.address.geo
          ) {
            if (
              a.location.address.geo.location.position &&
              (a.location.address.geo.location.position[0] == "0" ||
                a.location.address.geo.location.position[1] == "0")
            ) {
              this.geoCode(a);
            } else {
              if (!a.location.zone) {
                this.findZone(a.location);
              } else {
                var zones = this.shipmentObject.additionalModel.zone.filter(
                  (z) => {
                    return z._id == a.location.zone._id;
                  }
                );
                if (zones.length == 0) {
                  this.findZone(a.location);
                }
              }
            }
          } else {
            this.geoCode(a);
          }
        }
      });
    },
    geoCode(a) {
      var data = {
        address: a.location.address.address,
      };
      axios
        .post(this.serverURL + "/parse_address", data, {
          withCredentials: false,
        })
        .then((response) => {
          a.location.address.geo = {
            location: {},
          };
          a.location.address.geo.location.address = response.data.location;
          a.location.address.geo.location.position = response.data.position;
          this.findZone(a.location);

          data = {
            metadata: {
              object_name: "shipment",
            },
            model: this.shipmentObject.model,
          };

          axios.post(this.serverURL + "/add_data", data, {
            withCredentials: true,
          });
        })
        .catch((reason) => {
          // console.log(reason);
        });
    },
    recordActivities() {
      var action = parseInt(this.shipment_id)
        ? "open lead #" + this.shipment_id
        : "created new lead";
      var data = {
        metadata: {
          object_name: this.$root.store.userData.type,
        },
        model: {
          _id: this.$root.store.userData._id.$oid,
          last_action: action,
          last_action_time: fun.formatDate(
            new Date(),
            false,
            true,
            true,
            false,
            true
          ),
        },
      };

      axios.post(this.serverURL + "/add_data", data, {
        withCredentials: true,
      });
    },
    postToApp() {
      this.errorMessage = "";
      this.successMessage = "";
      var data = {
        shipment_id: [this.model.shipment_id],
      };
      axios
        .post(this.serverURL + "/post_to_app", data, {
          withCredentials: true,
        })
        .then((response) => {
          // console.log(response);
          if (response.data == "Job posted successfully") {
            this.successMessage = response.data;
          } else {
            this.errorMessage = response.data;
          }
        })
        .catch((reason) => {
          // console.log(reason);
        });
    },
    postToCallTools() {
      this.errorMessage = "";
      this.successMessage = "";
      var data = {
        _id: this.model._id,
      };
      axios
        .post(this.serverURL + "/create_contact_calltools", data, {
          withCredentials: true,
        })
        .then((response) => {
          console.log("calltools", response);
        })
        .catch((reason) => {
          console.log("calltools", reason);
        });
    },
    refreshModel(obj) {
      this.isLetter = obj.isLetter;
      this.currentModel = this.getModel(obj);
      if (obj.isLetter) {
        this.letterContainer(obj);
      }
    },
    reload(tab, reloadComp, nextTab) {
      this.mainKey = !this.mainKey;
      this.isClosing = false;
      if (!reloadComp) {
        this.movePlanKey = !this.movePlanKey;
      } else {
        // if (this.wizardIndex == -1) {
        //   this.refreshShipment(true);
        // }
        // this.movePlanKey = !this.movePlanKey;
        var obj = this.dataTabs[tab].obj;
        this.addTab(obj);
        this.currentModel = this.getModel(obj);
        this.currentSchema = this.getSchema();
        // this.formKey = !this.formKey;
      }

      // this.activeTabIndex = tab + 1 || 0;
    },
    addToMaterials(p, charges, noInventory) {
      var that = this;
      var material = that.shipmentObject.additionalModel.material_list.find(
        (item) => item.material_name === p.material_name
      );
      if (material && !noInventory) {
        var materialExists = this.model.inventory.find((c) => {
          return c.inventoryId == p._id && c.packingId == p.packingId;
        });
        if (materialExists) {
          materialExists.qty = p.qty;
        } else {
          this.model.inventory.push({
            _id: fun.guid(),
            item: material.material_name,
            qty: p.qty,
            inventoryId: p._id,
            packingId: p.packingId,

            room: p.room,
            volume: material.cu_ft,
          });
        }
      }
      if (material && charges) {
        var materialCharge = charges.find(
          (item) =>
            item.charge === material.material_name && item.inventoryId == p._id
        );
        var calcSubtotal = function() {
          var subtotal = 0;
          materialCharge.estimate_rate.forEach((m) => {
            subtotal += m.rate * m.qty || 0;
          });
          return subtotal.toFixed(2);
        };
        var addToCharges = function() {
          var chargeExists = charges.find((c) => {
            return c.inventoryId == p._id && c.packingId == p.packingId;
          });
          if (!chargeExists) {
            charges.push({
              _id: fun.guid(),
              charge_category: "material",
              estimate_rate: materialCharge.estimate_rate,
              charge: material.material_name,
              inventoryId: p._id,
              packingId: p.packingId,
              qty: p.qty,

              // description: i.item,
              subtotal: calcSubtotal(),
            });
          } else {
            chargeExists.qty = p.qty;
            chargeExists.subtotal = calcSubtotal();
          }
        };
        if (materialCharge) {
          var cont = materialCharge.estimate_rate.find(
            (item) => item.rate_name === "cont"
          );
          var pack = materialCharge.estimate_rate.find(
            (item) => item.rate_name === "pack"
          );
          if (cont) {
            cont.qty = parseInt(p.qty || 0);
            pack.qty = parseInt(p.qty || 0);
            materialCharge.subtotal = calcSubtotal();
          } else {
            addToCharges();
          }
        } else {
          materialCharge = {
            estimate_rate: [
              {
                rate_name: "cont",
                rate: material.container_price || 0,
                qty: p.qty,
              },
              {
                rate_name: "pack",
                rate: material.packing_price || 0,
                qty: p.qty,
              },
              {
                rate_name: "unpack",
                rate: material.unpacking_price || 0,
                qty: 0,
              },
            ],
          };
        }
        addToCharges();
      }
    },
    applyInventoryHandling(i, addBoxToInventory) {
      var services = this.model.estimate[this.getEstimateKey()]
        .shipment_service;
      if (i.handling) {
        services.forEach((s) => {
          if (!s.estimate_charges) {
            s.estimate_charges = [];
          }
          // var charges = s.estimate_charges;
          Object.keys(i.handling).forEach((key) => {
            if (key == "packing") {
              i.handling.packing.forEach((p) => {
                this.addToMaterials(
                  {
                    _id: i._id,
                    material_name: p.material_name,
                    packingId: p._id,
                    qty: i.qty * p.qty,
                    room: i.room,
                  },
                  s.estimate_charges,

                  addBoxToInventory
                );
              });
            } else if (key != "prompt") {
              var chargeName = fun.capitalize(key) + " - " + i.item;
              var charge = s.estimate_charges.find(
                (item) => item.charge === chargeName
              );

              if (charge) {
                charge.qty = parseInt(i.qty || 0);
                charge.subtotal = i.handling[key] * charge.qty;
              } else {
                s.estimate_charges.push({
                  qty: parseInt(i.qty || 0),
                  subtotal: i.handling[key] * i.qty,
                  estimate_rate: [
                    {
                      rate_name: key,
                      rate: i.handling[key] || 0,
                      qty: i.qty,
                    },
                  ],

                  charge: chargeName,
                  charge_category: "accessorials",
                });
              }
            }
          });
        });
      }
    },

    applyItemMaterials() {
      var service = this.model.estimate[this.getEstimateKey()]
        .shipment_service[0];
      if (!service.estimate_charges) {
        service.estimate_charges = [];
      }
      this.model.inventory.forEach((i) => {
        try {
          if (i.item.startsWith("(CP) ")) {
            this.addToMaterials(
              {
                material_name: i.item.replace("(CP) ", ""),
                qty: i.qty,
                _id: i._id,
              },
              service.estimate_charges,
              {},
              true
            );
          }
          if (i.handling && i.handling.packing) {
            i.handling.packing.forEach((p) => {
              this.addToMaterials(
                {
                  material_name: p.material_name,
                  qty: p.qty * i.qty,
                  packingId: p._id,
                  _id: i._id,
                  room: i.room,
                },
                service.estimate_charges
              );
            });
          }
        } catch (error) {
          //
        }

        // });
      });
    },
    hasInventory(serviceType) {
      return this.shipmentObject.additionalModel.service_type.find((t) => {
        return t.service_type == serviceType;
      }).has_inventory;
    },
    updateFullAddress(model, oldAddress, newAddress) {
      var stops = fun.getObjects(model, "full_address", oldAddress); // find all addresses with this full_address

      // if (geoAddress && geoAddress != obj.parModel.full_address) {

      stops.forEach((s) => {
        s.full_address = newAddress;
      });
    },
    submit(noValidate, updateOnly) {
      // if (this.saveButtonCaption == "Apply Payment") {
      //   this.chargeCard(this.currentModel);
      //   return;
      // }
      this.lastBtnClick = null;
      var formReady = true;
      this.currentItemHandlingId = null;
      var that = this;
      var data = {};
      if (this.$refs["form"]) {
        formReady =
          !this.$refs["form"][0] ||
          noValidate ||
          this.$refs["form"][0].validate();
      }

      if (formReady || updateOnly) {
        if (!updateOnly && !that.showVisualInventory) {
          this.loading = true;
          this.planReady = false;
        }
        var isStorage = false;
        if (this.activeTab && this.activeTab.tabId == "storage") {
          isStorage = true;
        }

        if (!isStorage) {
          if (this.currentModel) {
            this.applyItemMaterials();
            //        this.getTotalPayment(this.model);
            this.getTotalEstimate(this.model);
            var updateKeys = ["payment", "crm", "inventory"];
            Object.keys(this.currentModel).forEach((k) => {
              if (updateKeys.includes(k)) {
                // this.model[k] = this.currentModel[k];
                that.model[k] = fun.concatenateArrays(
                  that.model[k],
                  that.currentModel[k]
                );
              }
            });
          }
          if (!noValidate && !updateOnly && this.currentModel.shipmentId) {
            this.compareModel();
          }

          this.data.object_name = "v_shipment_with_zone_rate";
          data = {
            metadata: this.data,
            model: this.model,
          };
        } else {
          this.data.object_name = "storage";
          this.data.object_name_to_update = "";
          if (this.currentModel.storage.storage_id) {
            var qry = {
              storage_id: parseInt(this.currentModel.storage.storage_id),
            };
            this.data.qry = qry;
          }

          data = {
            metadata: this.data,
            model: this.currentModel.storage,
          };
          data.model.shipment_in = [this.shipment_id];
        }

        var whsAddresses = [];

        try {
          data.model.customer.address.forEach((a, i) => {
            if (a.existing_address && a.existing_address.warehouse_id) {
              whsAddresses.push(i);
            }
            delete a.existing_address;
            // a.use_existing = true;
            var geoAddress = fun.deepFind(a, "location.address.address");
            // this.updateFullAddress(data.model, a.full_address, geoAddress);
          });
        } catch (error) {
          //
        }
        if (data.model.customer.address && data.model.shipment_id) {
          data.model.customer.address = data.model.customer.address.filter(
            (a) => {
              return (
                a.full_address != "origin_address" &&
                a.full_address != "destination_address"
              );
            }
          );
        }

        if (whsAddresses.length) {
          whsAddresses.sort((a, b) => b - a);
          whsAddresses.forEach((index) => {
            if (index >= 0 && index < data.model.customer.address.length) {
              data.model.customer.address.splice(index, 1);
            }
          });
        }

        this.axios
          .post(this.serverURL + "/add_data", data, {
            withCredentials: true,
          })
          .then((response) => {
            that.loading = false;
            if (response.data.storage_id) {
              // var curIndex = fun.clone(this.activeTabIndex);
              // that.removeTab(curIndex - 1);

              // that.activeTabIndex = 0; // curIndex - 1;
              // that.refreshShipment(true);
              that.dataTabs = [];
              that.refreshShipment();

              that.showStorage({
                id: "storage",
                value: response.data.storage_id.toString(),
              });
              return;
            }
            // console.log("after axios", this._uid, this.loading);
            if (updateOnly) {
              this.$root.$emit("recalculateFields", this);
              return;
            }

            that.successMessageValue = true;
            that.successMessage = response.data.msg;
            that.afterSubmit(response.data);
            // var curIndex = fun.clone(that.activeTabIndex);
            // that.activeTabIndex = 0;
            var obj = {
              data_object: {
                object_name: "shipment",
              },
              model: that.model,
            };
            that.$root.$emit("record_updated", obj);
            // that.planReady = true;
            if (that.wizardIndex > -1) {
              that.getWizard(that.model);
            } else {
              // this.refreshShipment();
              if (!that.showVisualInventory) {
                that.movePlanKey = !that.movePlanKey;
                that.activeTabIndex = 0;
              }

              // setTimeout(function() {
              //   that.activeTabIndex = 0;
              // }, 1000);
            }
          });
      } else {
        const el = document.querySelector(".error--text");
        try {
          el.scrollIntoView();
        } catch (error) {
          //
        }

        return;
      }
    },
    getDataObject(t) {
      this.data_object.model = this.getModel(t);
      this.data_object.schema = this.getSchema();
      return this.data_object;
    },
    getMainTabs(t) {
      // this.mainTabs = [];
      var schema = null;
      if (t.obj.objectName == "shipment_service") {
        schema = this.shipmentObject.schema.properties.estimate.properties[
          "non-binding"
        ].properties.shipment_service;
      } else {
        schema = fun.getObjectsByKey(
          this.shipmentObject.schema.properties,
          t.obj.objectName
        )[0];
      }

      if (schema && schema["v-bind"]) {
        this.mainTabs = schema["v-bind"].mainTabs;
        this.tab = t;
      } else {
        // this.mainTabs = [];
        // this.tab = null;
      }
      // return this.mainTabs;
    },
    filterCharges() {
      var chargeSchema = fun.getObjectsByKey(
        this.shipmentObject.schema,
        "charge"
      )[1];
      var conditionalObject = null;
      try {
        conditionalObject = chargeSchema["v-bind"].conditionalObject;
      } catch (error) {
        //
      }

      var myCompany = this.shipmentObject.model.shipment_detail.company;
      this.shipmentObject.additionalModel.charge_list = this.shipmentObject.additionalModel.charge_list.filter(
        (c) => {
          return (
            (c.company &&
              c.company.some((company) => company._id === myCompany._id)) ||
            !c.company
          );
        }
      );
      this.shipmentObject.additionalModel.material_list = this.shipmentObject.additionalModel.material_list.filter(
        (c) => {
          return (
            (c.company &&
              c.company.some((company) => company._id === myCompany._id)) ||
            !c.company
          );
        }
      );
    },
    getChargeList(combo) {
      if (!combo) {
        return;
      }
      var value = combo.value;
      // var charge_category = combo.formModel.charge_category;
      var items = [];
      if (value == "material") {
        this.shipmentObject.additionalModel.material_list.forEach((i) => {
          items.push({
            rec: i,
            text: i.material_name,
            value: i.material_name,
          });
        });
      } else {
        var charges = this.shipmentObject.additionalModel.charge_list.filter(
          (p) => {
            return p.charge_category == value;
          }
        );
        if (value == "labor") {
          // console.log(charges);
          charges.forEach((i) => {
            var crewRates = i.crew_rate;
            crewRates.forEach((r) => {
              var chargeName = r.num_men + " men " + r.num_truck + " truck";
              items.push({
                rec: r,
                text: chargeName,
                value: chargeName,
              });
            });
          });
        } else {
          charges.forEach((i) => {
            items.push({
              rec: i,
              text: i.charge_name,
              value: i.charge_name,
            });
          });
        }
      }

      return items;
    },
    getModel(t) {
      if (!t) {
        t = {};
      }
      var data;
      var model = {};
      this.modelReady = false;
      if (t.obj == "storage" || t.id == "storage") {
        var value = t.storage_id || t.value;

        if (value) {
          data = {
            object_name: "storage",
            qry: {
              storage_id: parseInt(value),
            },
          };
          axios
            .post(this.serverURL + "/get_data", data, {
              withCredentials: true,
            })
            .then((response) => {
              this.currentModel = { storage: response.data.model[0] };
              this.modelReady = true;
              return this.currentModel;
            });
        } else {
          this.currentModel = {
            storage: {
              customer: this.model.customer,
              inventory: fun.clone(this.model.inventory),
            },
          };
          this.modelReady = true;
          return this.currentModel;
        }
      } else {
        var key = t.objectName || t.obj || t.id,
          filter = t.filter,
          parentObject = t.parentObject;

        if (parentObject) {
          var parentData = fun.getObjectByKey(
            this.model,
            parentObject.objectName
          );
          parentData = parentData.filter((r) => {
            return eval(parentObject.filter);
          })[0];
          data = parentData;
        } else {
          data = this.model;
        }
        if (key == "address") {
          data = data.customer;
        }

        var modelData = fun.getObjectByKey(data, key);
        var filteredData = null;

        if (filter && modelData) {
          filteredData = modelData.filter((r) => {
            return eval(filter);
          })[0];
          if (filteredData) {
            model[key] = filteredData;
          } else {
            var r = {};
            var d = filter.replace("==", "=");
            try {
              eval(d);
            } catch (error) {
              console.log(error);
            }
            if (r._id != "undefined") {
              modelData.push(r);
            } else {
              r = modelData[0];
            }
            model[key] = r;
          }
        } else {
          model[key] = modelData || {
            _id: model._id,
          };
        }
        if (!model._id) {
          model._id = this.model._id;
        }
        if (model.address && !model.address.location) {
          model.address = this.getLocationFromWarehouse({
            full_address: model.address.full_address,
          });
          // model.address.location.dwelling_type = {
          //   dwelling_type: "warehouse",
          // };
        }
        // if (key == "itinerary") {
        //   if (model.itinerary && !model.itinerary.crew) {
        //     model.itinerary.crew = {};
        //   }
        // }
        if (t.objectName == "shipment_service") {
          // if (!model.shipment_service.job_volume) {
          if (!model.shipment_service.ignore_inventory_for_volume) {
            model.shipment_service.job_volume = data.volume;
            model.shipment_service.job_weight = data.weight;
          }
          try {
            model.shipment_service.deposit_options = this.company.default_settings.deposit_options;
          } catch (error) {
            //
          }
          if (this.isClosing) {
            model.shipment_service = model.shipment_service[this.serviceIndex];
          }

          // if (!model.shipment_service.job_weight) {

          // }
        }
        if (t.objectName == "payment") {
          this.getAchDefault();
        }
        this.modelReady = true;
        if (this.noKeys.includes(key)) {
          return model;
        }

        return model[key];
      }
    },
    getAchDefault() {
      try {
        var achSchema = fun.getObjectByKey(this.shipmentObject.schema, "ach");
        console.log(achSchema);
        achSchema.properties["authorized_account_user"].default =
          this.model.customer.contact.first_name +
          " " +
          this.model.customer.contact.last_name;
        achSchema.properties["phone_number"].default = fun.extractNumericString(
          this.getMainPhoneNumber().toString(),
          true
        );
        var billingAddress = this.model.customer.address.find((a) => {
          return a.is_billing;
        });
        var apt = "";
        if (billingAddress) {
          apt = billingAddress.location.apt;
          billingAddress = billingAddress.location.address;
        } else {
          apt = this.model.customer.address[0].location.apt;
          billingAddress = this.model.customer.address[0].location.address;
        }
        billingAddress.apt = apt;
        achSchema.properties["address"].default = billingAddress;
      } catch (error) {
        //
      }
    },
    getNotesAndSms() {
      var properties = fun.clone(
        fun.getObjectByKey(this.shipmentObject.schema.properties, "crm")
      );
      var model = fun.clone(this.model.crm);
      properties["x-display"] = "d-table";

      this.notesAndSms.model = model.filter((m) => {
        return m.type == "note" || m.type == "sms";
      });
      // properties.properties.description["v-bind"].width = "100px";

      properties["v-bind"] = {
        hideTopBar: true,
        // table_title: "Notes And SMS",
        tableHeight: 50,
        noDelete: true,
        noExcel: true,
        editData: this.notesAndSms.model,
        fields_included: ["description"],
        noHorizontalScroll: true,
        dialogFields: [
          {
            width: "200px",
            iconFn:
              'var icon= i.type == "sms" ? "mdi-message-processing" : "mdi-note" ;icon',
            model: "description",
          },
        ],
        hideHeader: true,
      };
      this.notesAndSms.schema = { crm: properties };
    },
    getMainPhoneNumber() {
      var phoneKey = Object.keys(this.model.customer.contact.phones)[0];
      var phone = this.model.customer.contact.phones[phoneKey].phone_number;
      return phone.match(/\d+/g);
    },
    getSchema() {
      var tab = this.activeTab;
      if (!tab) {
        return;
      }
      this.mainTabs = [];
      var key = tab.tabId;
      if (!key) {
        return;
      }
      if (!this.shipmentObject) {
        return;
      }

      var properties = null;
      var schema = {};
      if (key == "storage") {
        schema = fun.clone(this.data_object.additional_structure.storage);
        // schema.properties.customer.hidden = true;
        // delete schema["v-bind"].mainTabs[0];
        properties = schema.properties;
      }
      // if (this.isClosing) {
      //   schema = fun.clone(this.shipmentObject.schema);

      //   // schema.hideFilterTabs = true;
      //   // var vBind = fun.getObjectByKey(schema.estimate_charges, "v-bind");
      //   // vBind.toolBarControls = [];
      //   // properties = fun.getObjectByKey(
      //   //   this.shipmentObject.schema.properties,
      //   //   "actual_service"
      //   // );
      //   // properties.table_properties.schema["v-bind"];
      else {
        properties = fun.getObjectByKey(
          this.shipmentObject.schema.properties,
          key
        );
      }

      // var vBind = fun.getObjectByKey(this.shipmentObject.schema["v-bind"], key);
      if (key != "storage" && !properties) {
        return;
      }

      if (tab.schema) {
        schema = tab.schema;
      } else {
        var prop = fun.clone(properties);
        prop["hidden"] = false;
        if (key == "itinerary") {
          prop["v-if-parameter"] = "";
        }
        if (
          key == "address" ||
          key == "shipment_service" ||
          key == "itinerary" ||
          key == "actual_service"
        ) {
          // if (!this.isClosing) {
          prop["x-display"] = "";
          // }
        }
        if (key != "storage") {
          schema[key] = prop;
        } else {
          schema = {
            storage: schema,
          };
        }
        if (tab.obj.itinerary_only) {
          Object.keys(prop.properties).forEach((p) => {
            if (p != "itinerary") {
              prop.properties[p].hidden = "true";
            }
          });
        }
      }
      if (tab.tabId == "address") {
        schema.address.properties.location.properties.address[
          "v-bind"
        ].doNotUpdateModel = true;
      }
      // schema["v-bind"] = vBind;
      if (fun.getObjectByKey(properties, "mainTabs")) {
        this.showTabs = true;
        this.getMainTabs(tab);
      } else {
        this.showTabs = false;
      }
      if (this.isClosing) {
        var vBind = fun.getObjectByKey(schema.shipment_service, "v-bind");
        vBind.mainTabs = [
          {
            tabName: "Charges",
            noCustomer: true,
            tabId: 0,
          },
          {
            tabName: "Payroll",
            noCustomer: true,
            tabId: 8,
          },
          {
            tabName: "Expenses",
            noCustomer: true,
            tabId: 7,
          },
        ];
      }

      if (this.noKeys.includes(key)) {
        return schema;
      }
      return schema[key].properties;
    },
    removeTab(tabToRemove) {
      this.letterBind = null;
      this.dataTabs.splice(tabToRemove, 1);
      this.isLetter = false;
      this.isPayment = false;
      this.saveButtonCaption = "Save Move Plan";
      this.letterReady = false;
      this.activeTabIndex = 0;
    },
    save() {
      try {
        this.$refs.form.$refs.form.formSubmit();
      } catch (error) {
        //
      }
    },
    onValueChange(m, f) {
      if (m.key === "booked") {
        var booked = this.bookService(m);
        // this.createTasks();
        this.reload(booked ? 0 : this.activeTabIndex);
      }
      if (m.key === "item_name") {
        this.calculateInventoryVolume();
      }
    },
    getEstimateKey(m) {
      var key = "";
      if (
        !this.shipmentObject ||
        !this.shipmentObject.model ||
        !this.shipmentObject.model.estimate
      ) {
        return "non-binding";
      }
      Object.keys(this.shipmentObject.model.estimate).forEach((k) => {
        if (
          m &&
          fun.getObjects(this.shipmentObject.model.estimate[k], "_id", m._id)
            .length
        ) {
          key = k;
        }
      });
      return key || "non-binding";
    },
    createSitSchedule(m, warehouseId) {
      var model = {
        shipment_id: m.shipment_id,
        warehouse_id: warehouseId,
        eta: m.service_date,
      };

      var data = {
        metadata: {
          object_name: "sit_schedule",
          id_fields: ["warehouse_id"],
        },
        model: model,
      };
      axios
        .post(this.serverURL + "/add_data", data, {
          withCredentials: true,
        })
        .then((response) => {
          console.log(response);
        });
    },
    createSchedule(m) {
      var parentModel = this.shipmentObject.model;
      var getEstimateKey = function() {
        var key = "";
        Object.keys(parentModel.estimate).forEach((k) => {
          if (fun.getObjects(parentModel.estimate[k], "_id", m._id).length) {
            key = k;
          }
        });
        return key;
      };
      var estimateKey = getEstimateKey();
      var schedule_id = m.schedule_id;

      var data = {
        metadata: {
          object_name: "schedule",
          date_fields: ["service_date"],
          id_fields: ["sid", "service_id"],
        },
        model: {
          sid: parentModel._id,
          service_id: m._id,
          service_date: m.service_date,
          book_date: m.book_date,
          booked_by: m.booked_by,
          estimate_key: estimateKey,
          shipment_stops: m.shipment_stop,
          route: m.route,
          _id: schedule_id,
          itinerary_id: "",
        },
      };
      axios
        .post(this.serverURL + "/add_data", data, {
          withCredentials: true,
        })
        .then((response) => {
          m.schedule_id = response.data._id;
          this.submit(false);
        })
        .catch((reason) => {
          // console.log(reason);
        });
    },
    bookService(m, f) {
      this.errorMessage = "";
      var that = this;
      var data = {};

      var msgTitle = "";
      var msg = "";
      var bulkBooking = !m.key;
      if ((!m.model && m.value) || bulkBooking) {
        m.model = this.services.find((s) => {
          return s._id == m.value;
        });
        if (this.services.length > 1) {
          m.model.booked = m.booked;
        } else {
          m.model.booked = !m.model.booked;
        }

        // bulkBooking = true;
      }

      if (m.model.booked) {
        if (
          !m.model.service_date ||
          m.model.service_date.trim().split(" ").length == 1
        ) {
          m.model.booked = false;
          this.model.shipment_detail.status = "estimate";

          if (!m.model.service_date) {
            msgTitle = "Date and Time required";
            msg = "Please enter scheduled service date and time";
          } else if (m.model.service_date.trim().split(" ").length == 1) {
            msgTitle = "Time required";
            msg = "Please enter scheduled service time";
          }

          this.$root.alertDialog(msgTitle, msg);
          return false;
        }
        m.model.status = "scheduled";
        // if (!m.model.route) {
        // this.calculateRoute(m.model);
        // }
        this.mainService.status = "scheduled";
        this.model.booked_estimate = this.getEstimateKey();
        this.model.shipment_detail.status = "booked";
        this.mainService.booked = true;
        m.model.booked_date = fun.formatDate(new Date(), false, true, true);
        m.model.booked_by = this.currentUser;
        this.model.shipment_detail.status_date_changed = m.model.booked_date;

        var serviceType = this.shipmentObject.additionalModel.service_type.find(
          (t) => {
            return t.service_type == m.model.service_type;
          }
        );
        if (serviceType.has_itinerary) {
          this.createItinerary(m.model);
        }

        this.createTasks();
        // if (!f) {
        this.submit(bulkBooking, bulkBooking);
        // }

        try {
          // this.refreshModel(this.dataTabs[this.activeTabIndex - 1].obj);
        } catch (error) {
          //
        }
      } else {
        var service_id = m.model._id;
        // m.model.booked = true;
        m.model.itinerary = [];
        m.model.status = "";
        m.model.book_date = null;
        m.model.booked_by = "";
        this.model.shipment_detail.status = "pending";
        this.model.shipment_detail.status_date_changed = fun.formatDate(
          new Date(),
          false,
          true,
          true
        );

        // if (!f) {
        this.submit(bulkBooking, bulkBooking);
        // }

        if (m.obj) {
          m.obj.componentKey = !m.obj.componentKey;
        }
      }

      var notBooked = this.services.some((s) => {
        return !s.booked;
      });
      var pl = this.services.length > 1 ? "" : "";

      this.bookBtn.title = notBooked ? "Book Now " + pl : "Unbook " + pl;
      this.bookBtn.menuItems.forEach((b) => {
        b.booked = !notBooked;
      });
      this.activeTabIndex = 0;
      this.$refs.movePlan.initMovePlan(true);
      // this.movePlanKey = !that.movePlanKey;
      // this.refreshShipment(true);
      // this.$forceUpdate();
    },
    getDeliveryDates(model, fn) {
      var that = this;
      if (!model.delivery_date_range) {
        console.log(model);
        var pickup = model.shipment_stop.filter((s) => {
          return (s.title = "pickup");
        })[0];
        var dropoff = model.shipment_stop.filter((s) => {
          return (s.title = "dropoff");
        })[0];
        if (pickup && dropoff) {
          var data = {
            object_name: "zone",
            qry: {
              _id: this.zoneFrom,
            },
          };
          axios
            .post(this.serverURL + "/get_data", data, {
              withCredentials: true,
            })
            .then((response) => {
              if (!that.zoneRates || !that.zoneRates.length) {
                that.zoneRates = response.data.model[0].zone_rate;
              }
              that.updateZoneRates();
              var rate = that.zoneRates.filter((r) => {
                return r.to_zone_id == that.zoneTo;
              });
              if (rate.length && model.service_date) {
                var dtf = rate[0].d_t_f;
                var pickupDate = new Date(model.service_date);
                var firstDate = pickupDate.setDate(
                  pickupDate.getDate() + parseInt(dtf)
                );
                var lastDate = pickupDate.setDate(
                  pickupDate.getDate() + this.deliveryDateFrame
                );
                model.delivery_date_range =
                  fun.formatDate(firstDate) + "-" + fun.formatDate(lastDate);
              }
              return rate;
            });
        }
      }
    },
    setReadOnly(serv, id) {
      serv.table.forEach((m, i) => {
        var ctl = serv.$refs["service_date"][i];
        ctl.setReadOnly("service_date", m.booked);
      });
    },
    getAgent(location) {
      var agent = this.shipmentObject.additionalModel.agent;

      var curAgent = agent.find(
        (item) =>
          item.zones &&
          item.zones.some(
            (zone) =>
              location.carrier_zone &&
              zone._id === location.carrier_zone.zone_id
          )
      );
      return curAgent;
    },
    createItinerary(m) {
      if (!m.itinerary || !m.itinerary.length) {
        var itinerary = [];
        var origin = this.getLocation("pickup");
        var destination = this.getLocation("dropoff");
        var warehouseOrig = this.getWarehouse(origin.location);
        var warehouseDest = this.getWarehouse(destination.location);
        var defaultItinerary = this.data_object.additional_model.service_type.filter(
          (t) => {
            return t.service_type == m.service_type;
          }
        )[0];
        if (defaultItinerary) {
          defaultItinerary.default_itinerary.forEach((i) => {
            var itineraryStep = {
              _id: fun.guid(),
              step: i,
            };
            var addProperties = {};

            switch (i) {
              case "d2d":
                addProperties = {
                  etd: m.service_date,
                  pickup_status: "booked",
                  delivery_status: "booked",
                  haul_type: "internal",
                  agent: {
                    _id: this.shipmentObject.model.shipment_detail.company,
                  },
                  crew: {},
                  origin: origin.full_address,
                  destination: destination,
                };
                break;
              case "d2w":
                addProperties = {
                  etd: m.service_date,
                  haul_type: "internal",
                  pickup_status: "booked",
                  delivery_status: "pending",

                  agent: this.getAgent(origin.location),
                  crew: {},
                  origin: origin.full_address,
                };
                if (warehouseOrig) {
                  addProperties.warehouse = {
                    _id: warehouseOrig._id,
                    warehouse_name: warehouseOrig.warehouse_name,
                  };
                }
                break;
              case "w2w":
                addProperties = {
                  // haul_type: "internal",
                  pickup_status: "booked",
                  delivery_status: "pending",

                  crew: {},
                };
                if (warehouseDest) {
                  addProperties.warehouse = {
                    _id: warehouseDest._id,
                    warehouse_name: warehouseDest.warehouse_name,
                  };
                }
                break;
              case "w2d":
                addProperties = {
                  // haul_type: "internal",
                  pickup_status: "booked",
                  delivery_status: "pending",
                  destination: destination.full_address,

                  crew: {},
                };
                if (warehouseOrig) {
                  addProperties.warehouse = {
                    _id: warehouseOrig._id,
                    warehouse_name: warehouseOrig.warehouse_name,
                  };
                }

                break;
            }

            itinerary.push({ ...itineraryStep, ...addProperties });
          });
        }

        m.itinerary = itinerary;
      }
    },
    getWarehouse(location) {
      if (location && location.zone) {
        var warehouse = this.shipmentObject.additionalModel.warehouse;
        if (!location.carrier_zone) {
          location.carrier_zone = location.zone;
        }
        var zones = this.shipmentObject.additionalModel.zone;
        var curZone = zones.filter((z) => {
          return z._id == location.carrier_zone.zone_id;
        })[0];
        var curWhs;
        if (curZone) {
          if (curZone.default_sit) {
            curWhs = warehouse.filter((w) => {
              return w._id == curZone.default_sit._id;
            })[0];
          } else {
            // curWhs = this.getClosestWhs(location, warehouse);
            curWhs = warehouse.find(
              (item) =>
                item.zones &&
                item.zones.some(
                  (zone) => zone._id === location.carrier_zone.zone_id
                )
            );
          }
        }

        return curWhs;
      }
    },
    getClosestWhs(location, warehouse) {
      var pos = fun.deepFind(location, "address.geo.location.position");
      if (pos) {
        var mileage = 100000;
        var closestWhs = null;
        warehouse.forEach((w) => {
          var whsPos = fun.deepFind(w, "geo.position");
          if (whsPos) {
            var m = fun.mileage(pos[0], pos[1], whsPos[0], whsPos[1]);
            if (parseFloat(m) && parseFloat(m) < mileage) {
              mileage = parseFloat(m);
              closestWhs = w;
            }
          }
        });
      }
      return closestWhs;

      //
    },
    refreshShipment(reload) {
      var that = this;
      this.shipmentRefreshed = false;
      this.shipment_id = this.$route.params.id || this.shipmentId;
      // this.loading = true;
      this.data = {
        object_name: "v_shipment_with_zone_rate",
        schema_name: "shipment",
        object_name_to_update: "shipment",

        single_record: true,
        qry: parseInt(this.shipment_id)
          ? {
              shipment_id: parseInt(this.shipment_id),
            }
          : "",
        portal_id: this.$session.get("portal_id"),
        main_model: "shipment",
      };
      // if (!this.shipmentObject) {
      var addData = {
        additional_data: [
          {
            obj_name: "company",
          },
          {
            obj_name: "charge_list",
          },
          {
            obj_name: "material_list",
          },
          {
            obj_name: "service_type",
          },
          {
            obj_name: "charge_category",
          },
          {
            obj_name: "delivery_status",
          },
          {
            obj_name: "room",
          },
          {
            obj_name: "task",
          },
          {
            obj_name: "employee",

            qry: {
              _id: this.$root.user_id,
            },
          },

          {
            obj_name: "warehouse",
          },
          {
            obj_name: "v_sent_letters",

            qry: {
              shipment_id: parseInt(this.shipment_id),
            },
          },
          {
            obj_name: "zone",

            fields: [
              "_id",
              "zone_name",
              "states",
              "counties",
              "cities",
              "movetype",
              "type",
            ],
          },
          {
            obj_name: "agent",
            // qry: {
            //   type: "tariff_zone",
            // },
            fields: ["_id", "contact", "zones", "has_own_tariff"],
          },
          {
            obj_name: "stage",
          },
          {
            obj_name: "rate_list",
            data_name: "labor_rates",
            qry: {
              charge_type: "transportation_hourly_based",
            },
          },
          {
            obj_name: "lead_status",
          },
        ],
        additional_structure: [
          {
            obj_name: "charges",
          },
          {
            obj_name: "shipment_service",
          },
          {
            obj_name: "storage",
          },
        ],
      };

      this.data = {
        ...this.data,
        ...addData,
      };
      // }

      this.refreshData(reload);
    },
    getAllowedCompanies(addData) {
      if (this.$root.filteredCompanies()) {
        var companies = addData.additional_data.find((o) => {
          return o.obj_name == "company";
        });

        // companies.id_fields = ["_id"];

        var filterCompanyQry = {
          _id: { $in: this.$root.filteredCompanies() },
        };

        companies.qry = filterCompanyQry;
      }
    },
    getZones() {
      try {
        var origin = this.getLocation("pickup");
        if (origin) {
          this.zoneFrom = origin.zone_id || origin.location.zone.zone_id;
        }
      } catch (error) {
        //
      }

      try {
        var destination = this.getLocation("dropoff");
        if (destination) {
          this.zoneTo =
            destination.zone_id || destination.location.zone.zone_id;
        }
      } catch (error) {
        //
      }
    },
    getLocation(stopType) {
      var stops = this.model.estimate[this.getEstimateKey()].shipment_service[0]
        .shipment_stop;
      var st = stops.filter((s) => {
        return s.value == stopType || s.stop_type == stopType;
      })[0];
      var location = this.model.customer.address.filter((a) => {
        return a.full_address == st.full_address;
      })[0];
      // console.log(location);
      if (!location) {
        location = this.getLocationFromWarehouse(st);
      }

      return location;
    },
    getLocationFromWarehouse(st) {
      var location = {};
      var warehouse = this.shipmentObject.additionalModel.warehouse.find(
        (a) => {
          return a.address && a.address.address == st.full_address;
        }
      );
      if (warehouse) {
        var whsAddr = warehouse.address ? warehouse.address.address : "";
        if (warehouse.address) {
          var geo = warehouse.address.geo || warehouse.geo;
          if (geo) {
            location = {
              full_address: whsAddr,
              location: {
                full_address: whsAddr,
                dwelling_type: {
                  dwelling_type: "storage",
                },
                warehouse_id: warehouse._id,
                is_warehouse: true,
                address: {
                  address: whsAddr,

                  geo: {
                    location: {
                      address: geo.location.address || geo.location,
                      position: geo.location.position || geo.position,
                    },
                  },
                },
              },
            };
          }
        }
      }
      return location;
    },
    updateZoneRates() {
      var that = this;
      if (!this.zoneRates) {
        return;
      }
      this.zoneRates.forEach((z, i) => {
        if (z.company_zone_rate) {
          var company_rates = z.company_zone_rate.find((r) => {
            return true;
          });

          z = {
            ...z,
            ...company_rates,
          };
          delete z.company_zone_rate;
          this.zoneRates[i] = z;
        }
      });
    },
    refreshData(reload) {
      var that = this;
      var timeStarted = new Date();
      // this.loading = true;

      // this.data.add_function = "get_files";

      axios
        .post(this.serverURL + "/get_data", this.data, {
          withCredentials: true,
        })
        .then((response) => {
          this.deliveryStatus = response.data.additional_model.delivery_status;
          if (this.$root.filteredCompanies()) {
            const filteredCompanyIds = this.$root.filteredCompanies();
            response.data.additional_model.company = response.data.additional_model.company.filter(
              (company) => filteredCompanyIds.includes(company._id)
            );
          }

          if (!that.shipmentObject) {
            if (
              response.data.model.crm &&
              response.data.model.crm.length > 1000
            ) {
              response.data.model.crm = response.data.model.crm.filter((c) => {
                return c.type != "history";
              });
            }

            that.shipmentObject = {
              model: response.data.model,
              additionalModel: response.data.additional_model,
              schema: response.data.schema,
              objectName: "shipment",
            };
          } else {
            that.shipmentObject.model = response.data.model;
          }
          if (!this.shipmentObject.model.shipment_detail) {
            this.data_object.additional_model = this.shipmentObject.additionalModel;
            this.addDefaultShipmentDetail(this.shipmentObject.model);
            this.calculateRoute(
              this.shipmentObject.model.estimate["non-binding"]
                .shipment_service[0],
              true
            );
          }

          if (response.data.model._id) {
            that.model_id = response.data.model._id;
            this.filterCharges();
          }
          if (response.data.model.storage_id) {
            response.data.model.storage = [];
            response.data.model.storage_id.forEach((s) => {
              response.data.model.storage.push({ storage_id: s });
            });
            this.movePlanKey = !this.movePlanKey;
          }
          this.loading = false;
          that.model = this.shipmentObject.model;
          try {
            this.shipmentClosed = !this.model.estimate[
              this.getEstimateKey()
            ].shipment_service.some((s) => {
              return !s.closed;
            });
          } catch (error) {
            //
          }

          // console.log("shipment closed", that.shipmentClosed);
          // that.shipmentObject.model.crm = that.shipmentObject.model.crm.filter(
          //   (c) => {
          //     return c.type != "letters";
          //   }
          // );
          // that.shipmentObject.additionalModel.v_sent_letters.forEach((l) => {
          //   that.shipmentObject.model.crm.push({
          //     type: "letters",
          //     action_date_time: l.time_sent,
          //     letter_id: l._id,

          //     user: this.currentUser,
          //     description: l.letter_name,
          //     time_stamp: l.time_sent,
          //   });
          // });

          try {
            that.getNotesAndSms();
          } catch (error) {
            //
          }

          var company = fun.deepFind(this.model, "shipment_detail.company");
          if (company) {
            this.companyId = company._id || company;
          }

          if (that.model.estimate) {
            that.parseAddresses();
            if (!this.companyId) {
              try {
                var pickup = this.shipmentObject.model.customer.address[0];
                this.assignCompany(pickup.location);
                this.submit(true, true);
              } catch (error) {
                console.log(error);
              }
            }
            this.getZones();

            this.zoneRates = that.model.zone_rate;

            try {
              this.updateZoneRates();
            } catch (error) {
              //
            }

            this.storage = that.model.storage;
          }

          this.data_object = response.data;

          if (!this.model._id) {
            this.model.use_wizard = true;
            this.addDefaultData(this.data_object);
            if (this.$route.params.id == "0" && this.$root.customerId) {
              this.model.customer = { _id: this.$root.customerId.$oid };
              this.submit();
            }
          } else {
            var model = this.data_object.model;
            this.addMissingPropertis(model);
          }
          this.hasOriginStorage = true;
          this.hasDestinationStorage = true;
          this.mainService = this.model.estimate[
            "non-binding"
          ].shipment_service[0];

          this.fixStops();
          this.fixCharges();

          this.company = this.shipmentObject.additionalModel.company.filter(
            (c) => {
              return c._id == that.companyId;
            }
          )[0];
          // this.movePlanKey = !this.movePlanKey;

          if (!this.model.inventory.length) {
            this.model.inventory = [];
          }
          if (
            !this.model.onsite_estimate ||
            !this.model.onsite_estimate.length
          ) {
            this.model.onsite_estimate = [];
          }
          if (!this.model.payment.length) {
            this.model.payment = [];
          }
          this.inventory = this.model.inventory;
          // console.log(this.inventory);

          if (reload) {
            this.movePlanKey = !this.movePlanKey;
            this.formKey = !this.formKey;
            this.tabKey = !this.tabKey;
            this.letterKey = !this.letterKey;
            this.$refs.movePlan.initMovePlan(true);
          }
          // if (this.zoneFrom && this.zoneTo) {
          //   this.getZoneRate();
          // } else {
          //   // this.planReady = true;

          // }
          if (model) {
            this.getTotalPayment(model);
            this.getTotalEstimate(model);
          }

          this.populateLettersMenu(response.data.model.document);
          // this.populateLettersMenu(response.data.additional_model.document);

          var curStatus = fun.capitalize(
            this.model.shipment_detail ? this.model.shipment_detail.status : ""
          );
          this.statusMenuBtn = {
            // color: "info",
            color: this.getColor(),
            title: "Status: " + curStatus,
            capitalizeText: true,
            objectName: "lead_status",
            itemText: "status",
            itemValue: "status",
            filter: "r.status!='booked' && r.status!='closed'",
            small: true,
            text: true,
            textBelow: true,
            sort: "status",

            // icon: "mdi-escalator",
          };

          this.getWizard(model);
          this.getServices();
          var services = [];
          that.services.forEach((s) => {
            if (s.service_date) {
              services.push({
                text: fun.capitalize(s.service_type) + " " + s.service_date,
                value: s._id,
                booked: s.booked && s.status != "customer_request",
              });
            }
          });
          var notBooked = this.services.some((s) => {
            return !s.booked;
          });
          var pl = this.services.length > 1 ? "services" : "";

          this.bookBtn = {
            title: notBooked ? "Book Now " + pl : "Unbook " + pl,
            capitalizeText: true,
            menuItems: services,
            textBelow: true,
            selectable: true,
            selectProperty: "booked",
            selectAllCaption: ["Book", "Unbook"],
            changeSelect: this.bookService,
          };

          this.planReady = true;
          this.checkPermissions();
          this.$root.$emit("shipment_loaded", model.shipment_id);
        })
        .catch((reason) => {
          // console.log(reason);
        });
    },
    getWizard(model) {
      if (
        this.shipmentObject.model.no_wizard ||
        !this.shipmentObject.model.use_wizard
      ) {
        this.noWizard = true;
      }
      if (this.noWizard) {
        return;
      }

      if (
        this.wizardIndex == this.wizardSteps.length - 1 &&
        this.saveButtonCaption == "Save Move Plan"
      ) {
        this.activeTabIndex = 0;
        this.noWizard = true;
        this.dataTabs = [];

        return;
      }
      var t = null;
      var service = model.estimate["non-binding"].shipment_service[0];
      if (service.shipment_stop[0].full_address == "origin_address") {
        this.wizardIndex = this.$root.customerId ? 0 : 1;
      } else if (
        service.shipment_stop[1].full_address == "destination_address"
      ) {
        this.wizardIndex = this.$root.customerId ? 1 : 2;
        try {
          this.postToCallTools();
        } catch (error) {
          //
        }
      } else if (
        this.wizardSteps.length > 3 &&
        !model.inventory.length &&
        this.wizardSteps.find((s) => {
          return s.id == "inventory";
        })
      ) {
        this.wizardIndex = this.$root.customerId ? 2 : 3;
        // } else if (!service.total_estimate) {
        //   this.wizardIndex = 4;
        this.wizardSteps[this.wizardIndex].filter =
          "r._id =='" + service._id + "'";
        //   this.wizardSteps[this.wizardIndex].serviceId = service._id;

        // this.wizardSteps[this.wizardIndex - 1].id = service.service_type;
      } else if (!model.inventory.length && this.wizardSteps.length > 3) {
        this.wizardIndex = this.$root.customerId ? 2 : 3;
        this.wizardIndex += 1;
        if (
          this.wizardSteps[this.wizardSteps.length - 1] &&
          this.wizardSteps[this.wizardSteps.length - 1].id == "job"
        ) {
          if (service && service.service_date) {
            this.wizardIndex = -1;
          } else {
            this.wizardSteps[this.wizardIndex].filter =
              "r._id =='" + service._id + "'";
          }
        }
      }

      if (this.wizardIndex > -1) {
        for (let i = 0; i <= this.wizardIndex; i++) {
          //          filter: "r.full_address=='origin_address'",
          var wizStep = this.wizardSteps[i];
          if (wizStep.objectName == "address") {
            try {
              var index = i - 1;
              if (this.$root.customerId) {
                index = i;
              }
              var fullAddress = "";
              if (this.model.customer.address[index]) {
                fullAddress =
                  service.shipment_stop[index].full_address ||
                  this.model.customer.address[index].full_address;
              }
              if (service.shipment_stop.length >= index + 1 || !fullAddress) {
                // var fullAddress = service.shipment_stop[index].full_address;
                wizStep.filter = "r.full_address=='" + fullAddress + "'";
              }
            } catch (error) {
              //
            }
          }
          try {
            this.addDefaultTab(wizStep, i);
          } catch (error) {
            //
            console.log(error);
          }

          // if (this.$root.customerId) {
          //   this.wizardIndex -= 1;
          // }
        }
        this.activeTabIndex = this.wizardIndex + 1;

        if (this.wizardIndex < this.wizardSteps.length - 1) {
          this.saveButtonCaption =
            "Next: " + this.wizardSteps[this.wizardIndex + 1].title;
          this.saveButtonIcon = "mdi-skip-next";
        } else {
          this.saveButtonCaption = "Save Move Plan";
          this.saveButtonIcon = "mdi-check";
        }
      }
      // console.log("wizard done");
    },
    getPath(object, previousPath) {
      var arrayControls = [
        "d-table",
        "v-charge",
        "v-labor",
        "d-iterator",
        "v-data-time-line",
        "v-collapsible",
      ];
      for (var key in object) {
        let currentPath = previousPath ? `${previousPath}.${key}` : key;
        var v;
        if (object[key].type == "object") {
          v = this.fixedModel[currentPath];
          if (!v) {
            if (arrayControls.includes(object[key]["x-display"])) {
              this.fixedModel[currentPath] = [{}];
            } else {
              this.fixedModel[currentPath] = {};
            }
          }
        }
        if (object[key].properties) {
          this.getPath(object[key].properties, currentPath);
        }
      }
    },
    fixLetterModel() {
      this.fixedModel = this.data_object.additional_model.v_shipment_letter_fields[0];
      try {
        var path = this.getPath(this.shipmentObject.schema.properties);
      } catch (error) {
        console.log(error);
      }

      // console.log(path);
      var objects = fun.getObjects(
        this.shipmentObject.schema.properties,
        "type",
        "object"
      );
      var objectNames = [];
      objects.forEach((o) => {
        if (o.object_type) {
          objectNames.push(o.object_type);
        }
      });
      objectNames.forEach((n) => {
        var v = fun.getObjectsByKey(this.fixedModel, n);
        if (!v || !v.length) {
          var p = fun.findPath(this.fixedModel, n, v);
          v = {};
        }
      });

      this.fixedModel.total_estimate = this.model.total_estimate;
      if (this.model.shipment_detail.sales_person) {
        this.fixedModel.shipment_detail.sales_person = this.model.shipment_detail.sales_person._id;
      }

      this.fixedModel.balance = (
        this.fixedModel.total_estimate - this.totalPayment
      ).toFixed(2);
      this.letterModel = this.fixedModel;
    },
    getLetters(feedback) {
      var data = {
        object_name: "document",
        qry: {
          $or: [
            { company: this.companyId },
            { $ne: "company" },
            { company: null },
          ],
        },
      };
      axios
        .post(this.serverURL + "/get_data", data, {
          withCredentials: true,
        })
        .then((response) => {
          // console.log(response.data);
          this.populateLettersMenu(response.data.model);
        });
    },
    populateLettersMenu(l) {
      var that = this;
      var items = [];
      l.forEach((d) => {
        items.push({
          itemText: d.document_name,
          itemValue: d._id,
          click: function(p) {
            this.data = {
              object_name: "document",
              qry: {
                _id: d._id,
              },
              additional_data: [
                {
                  obj_name: "v_shipment_letter_fields",

                  qry: {
                    shipment_id: parseInt(that.shipment_id),
                  },
                },
              ],
            };

            axios
              .post(that.serverURL + "/get_data", this.data, {
                withCredentials: true,
              })
              .then((response) => {
                var bodyTemplate = "";
                let model = response.data.model;

                this.$root.getObjectStructure(
                  "translate/letter_fields.json",
                  model[0].body,
                  (r) => {
                    bodyTemplate = r;

                    p.dialogVBind = {
                      email: that.model.customer.contact.email,
                      documentId: d._id,
                      eMailSubject: model[0].email_subject,
                      model: that.letterModel,
                      letterId: model[0]._id,
                      bodyTemplate: "<div>" + bodyTemplate + "</div>",
                    };
                  }
                );
              })
              .catch((reason) => {
                errorsHandler(reason);
              });
          },
        });
      });
      fun.sortObjects(items, "itemText");
      this.letterMenuBtn = {
        title: this.$vuetify.breakpoint.mdAndUp ? "Letters and Documents" : "",
        menuItems: items,
        small: false,
        text: true,
        // color: "yellow",
        // color: "warning",
        icon: "mdi-email",
      };
      this.planReady = true;
    },
    getTotalPayment(model) {
      this.totalPayment = 0;
      if (model.payment && Array.isArray(model.payment)) {
        model.payment.forEach((p) => {
          this.totalPayment += parseFloat(p.amount);
        });
      }
      this.totalPayment = this.totalPayment.toFixed(2);
    },
    getTotalEstimate(model) {
      var estimateKey = model.estimate
        ? Object.keys(model.estimate)[0]
        : "non-binding";
      var services = model.estimate[estimateKey].shipment_service;

      this.totalEstimate = 0;
      services.forEach((s) => {
        if (s.estimate_charges) {
          s.total_estimate = s.is_flat_rate
            ? s.flat_rate
            : s.estimate_charges
                .reduce((sum, item) => sum + parseFloat(item.subtotal), 0)
                .toFixed(2);
          if (s.total_estimate && !isNaN(s.total_estimate)) {
            this.totalEstimate += parseFloat(s.total_estimate);
          }
          s.estimate_charges.forEach((c) => {
            if (!c.actual) {
              c.actual = c.subtotal;
            }
          });
          s.total_actual = s.estimate_charges
            .reduce((sum, item) => sum + parseFloat(item.actual), 0)
            .toFixed(2);
        }
      });
      this.balance = this.totalEstimate - this.totalPayment;
      this.balance = this.balance.toFixed(2);
      this.totalEstimate = parseFloat(this.totalEstimate).toFixed(2);

      this.shipmentObject.model.total_estimate = this.totalEstimate;
      // }
    },
    fixStops() {
      var model = this.shipmentObject.model;
      var estimateKey = Object.keys(model.estimate)[0];
      var services = model.estimate[estimateKey].shipment_service;
      services.forEach((s) => {
        var stops = s.shipment_stop || [];
        s.shipment_stop = this.formatStops(stops);
        if (s.booked == "0") {
          s.booked = 0;
        }
      });
      return services;
    },
    getZoneRate() {
      var data = {
        object_name: "zone",
        qry: {
          _id: this.zoneFrom,
        },
      };
      axios
        .post(this.serverURL + "/get_data", data, {
          withCredentials: true,
        })
        .then((response) => {
          // console.log(response.data);
          if (response.data.model && response.data.model[0]) {
            this.zoneRates = response.data.model[0].zone_rate;
            if (this.zoneRates) {
              this.zoneRates = this.zoneRates.filter((r) => {
                return r.to_zone_id == this.zoneTo;
              });
            } else {
              this.zoneRates = [];
            }
          }
          this.updateZoneRates();
          this.addAllEvents();
        });
    },
    fixCharges() {
      var services = this.model.estimate[this.getEstimateKey()]
        .shipment_service;
      services.forEach((s) => {
        if (s.estimate_charges) {
          s.estimate_charges.forEach((c) => {
            if (!c.estimate_rate || !c.estimate_rate.length) {
              if (typeof c.charge === "object") {
                if (c.charge.labor_type) {
                  c.description = c.charge.labor_type;
                  c.charge = c.men + " Men " + c.truck + " Truck ";
                }

                //
              }
              c.estimate_rate = [];
              c.estimate_rate.push({
                rate_name: "rate",
                qty: c.qty || 1,
                rate: c.rate || 0,
              });
            }
            if (
              !c.charge_category &&
              c.charge &&
              typeof c.charge === "string"
            ) {
              if (
                c.charge.toLowerCase().includes("box") ||
                c.charge.toLowerCase().includes("pack")
              ) {
                c.charge_category = "material";
              } else {
                c.charge_category = "accessorials";
              }
            }
            if (!c.subtotal) {
              c.subtotal = (c.rate * c.qty).toFixed(2);
            }
          });
        }
      });
    },
    createServices() {
      var model = this.data_object.model;
      var estimateKey = Object.keys(model.estimate)[0];
      var estimate = model.estimate[estimateKey];
      estimate.shipment_service = [];
      var serviceType = this.data_object.service_type;

      model.requested_services.forEach((s) => {
        var service = {
          // _id: fun.guid(),
          service_type: s.service_type,
          service_date: s.date,
        };

        service.shipment_stop = [];
        var n = 2;
        model.customer.address.forEach((a, i) => {
          var stop_type = i == 0 ? "pickup" : "dropoff";
          var typeExist = service.shipment_stop.filter((st) => {
            return st.stop_type == stop_type;
          });

          if (typeExist.length) {
            stop_type = stop_type + "_" + n;
            n += 1;
          }
          var sType = serviceType.filter((t) => {
            return t.service_type == s.service_type;
          });
          if (sType.length) {
            sType = sType[0];
          }
          if (
            !sType ||
            !sType.stop_type ||
            sType.stop_type.includes(a.address_type)
          ) {
            service.shipment_stop.push({
              address_label: a.address_type,
              stop_type: stop_type,
              stop_number: i + 1,
            });
          }
        });
        estimate.shipment_service.push(service);
      });
    },

    updateLocations() {
      // this.setStops(true);
      var locationKeys = [];
      var allStopKeys = this.data_object.schema.properties.shipment_stop
        .table_properties.schema.properties;
      var shipment_stop = this.data_object.model.shipment_stop;
      Object.keys(allStopKeys).forEach((k) => {
        if (!this.stopKeys.includes(k)) {
          locationKeys.push(k);
        }
      });
      locationKeys.forEach((k) => {
        shipment_stop.forEach((s) => {
          delete s[k];
        });
      });
    },
    locationExists(s) {
      var id;
      return id;
    },
    addMissingPropertis(model) {
      if (!model.crm || !model.crm.length) {
        model.crm = [];
      }
      if (!model.payment || !model.payment.length) {
        model.payment = [];
      }
      if (
        !model.shipment_detail ||
        !Object.keys(model.shipment_detail).length
      ) {
        this.addDefaultShipmentDetail(model);
      }
      if (!model.consignee) {
        model.consignee = {
          contact: {},
        };
      }
      if (!model.attachments) {
        model.attachments = {};
      }
    },
    addDefaultShipmentDetail(model) {
      model.shipment_detail = {};
      model.shipment_detail.sales_person = this.$root.user_id;

      if (
        this.data_object.additional_model.company &&
        this.data_object.additional_model.company.length
      ) {
        var company = this.data_object.additional_model.company.filter((c) => {
          return c.is_default;
        })[0];
        if (!company) {
          company = this.data_object.additional_model.company[0];
        }

        model.shipment_detail.company = company;
      }

      model.shipment_detail.status = (model.lead_status || "New").toLowerCase();
      model.shipment_detail.order_date_time = fun.formatDate(
        new Date(),
        false,
        true,
        true
      );
      this.addDefaultCRM(model);
    },
    addDefaultCRM(model) {
      var crm = {
        type: "status",
        description: "New Estimate Created",
        status: "new",
        user: this.currentUser,
        time_stamp: fun.formatDate(new Date(), false, true, true),
      };
      model.crm = [crm];
    },
    addDefaultData(data_object) {
      var model = data_object.model;
      model.crm = [];
      model.customer = {
        contact: {
          // first_name: "test",
          // last_name: "app",
          // email: "test@app.com",
          phones: {
            mobile: {
              phone_type: "mobile",
              phone_number: "",
            },
          },
        },
      };
      var company = data_object.additional_model.company[0];
      var defaultTypeOfMove = company.default_settings
        ? company.default_settings.default_type_of_move ||
          "long_distance_moving"
        : "long_distance_moving";

      model.estimate = {
        "non-binding": {
          shipment_service: [
            {
              // _id: fun.guid(),
              service_type: defaultTypeOfMove,
            },
          ],
        },
      };
      model.inventory = [];

      model.attachments = {};
      model.customer.address = [
        {
          full_address: "origin_address",
          location: {},
        },
        {
          full_address: "destination_address",
          location: {},
        },
      ];
      this.addDefaultShipmentDetail(model);
      this.model = model;

      this.saveButtonIcon = "mdi-skip-next";
      this.saveButtonCaption = "Next: " + this.wizardSteps[1].title;

      this.addDefaultTab(this.wizardSteps[0]);
    },
    getColor() {
      // mainService && mainService.booked ? 'green accent-4' : 'grey  accent-4'
      if (
        this.shipmentObject &&
        this.shipmentObject.additionalModel &&
        this.shipmentObject.additionalModel.lead_status
      ) {
        try {
          var curStatus = this.shipmentObject.additionalModel.lead_status.filter(
            (s) => {
              return (
                s.status.toLowerCase() ==
                (this.model.shipment_detail.status.toLowerCase() ||
                  this.model.lead_status.toLowerCase())
              );
            }
          );
          return curStatus[0].color;
        } catch (error) {
          return "";
        }
      }
      return "";
    },
    invertColor() {
      return fun.invertColor(this.getColor());
    },
    addDefaultTab(t, s) {
      this.isClosing = false;
      this.addTab(t);
      this.currentSchema = this.getSchema();
      this.currentModel = this.getModel(t);

      this.activeTabIndex = s || 1;
    },

    afterSubmit(form) {
      // console.log(form.model);
      if (!this.shipment_id || this.shipment_id == "0") {
        var link = "/shipment/" + form.shipment_id;
        this.shipment_id = form.shipment_id;

        // this.$root.reset = true;
        // this.$root.$router.push({
        //   path: link,
        // });
        this.$root.resentTabs.filter((t) => {});
        const index = this.$root.resentTabs.findIndex(
          (obj) => obj["shipment_id"] === "0"
        );
        if (index != -1) {
          this.$root.removeResentTab(index);
        }

        this.$root.addResentTab({
          first_name: this.model.customer.contact
            ? this.model.customer.contact.first_name
            : "",
          last_name: this.model.customer.contact
            ? this.model.customer.contact.last_name
            : "",
          shipment_id: form.shipment_id,
        });
        this.shipmentObject = null;
        this.mainKey = !this.mainKey;

        // this.$root.tabKey = !this.$root.tabKey;
        // this.reload(false, false, true);
        // } else {
        //   this.refreshShipment();
      }
    },
    addDefaultCharges(model) {
      var serviceTypes = this.data_object.additional_model.service_type;
      model.estimate["non-binding"].shipment_service.forEach((s) => {
        s.estimate_charges = [];
        var defaultCharges = serviceTypes.filter((t) => {
          return t.service_type == s.service_type;
        });
        defaultCharges.forEach((d) => {
          d.default_charges.forEach((c) => {
            s.estimate_charges.push({
              charge_category: c,
            });
          });
        });
      });
      this.model = model;
    },

    showShipmentProperties(hide) {
      this.submitButtonCaption = hide ? "Continue" : "Save";
      var properties = this.data_object.schema.properties;

      properties.customer.properties.address.hidden = !hide;
      properties.requested_services.hidden = !hide;
      properties.estimate.hidden = hide;
    },
    onGetData(data_object, f) {
      var that = this;

      this.data_object = data_object;
      this.model = data_object.model;
      this.getCaption(data_object.model);

      data_object.company = data_object.additional_model.company[0];
      data_object.all_tariff = data_object.additional_model.tariff_list;
      data_object.service_type = data_object.additional_model.service_type;
      if (!this.model.shipment_detail) {
        this.model.shipment_detail = {};
      }

      if (this.model._id) {
        this.showShipmentProperties(false);
        // this.setStops();
      } else {
        if (!this.testMode) {
          this.addDefaultData(data_object);
        } else {
          data_object.model = this.testData;
        }

        this.showShipmentProperties(true);
      }

      that.parentModel = that.data_object.model;
      data_object.schema = that.data_object.schema;
      this.inventory = this.model.inventory;
      this.populateMenues();
      Object.keys(data_object.schema.properties.estimate.properties).forEach(
        (p) => {
          var estimate = data_object.schema.properties.estimate.properties[p];
          estimate.properties.shipment_service.recordAction = {
            icon: "mdi-calculator",
            caption: "Recalculate",
            fn: that.recalculateService,
          };
        }
      );
      // this.letterModel = { ...this.model, ...{ company: data_object.company } };
      this.letterKey = !this.letterKey;

      f.formKey = !f.formKey;
    },
    serviceTypeModel(t) {
      // console.log(t);
    },
    shipmentstopSchema(t) {
      if (!t) {
        return {};
      }
      var item = t.r;
      var model = t.formModel;
      var stops = 1;
      if (model.shipment_stop) {
        stops =
          model.shipment_stop.filter((s) => {
            return s._id;
          }).length + 1;
      }
      if (item) {
        var m = {
          stop_type: item.value,
          stop_number: stops,
        };

        return m;
      } else {
        return {};
      }
    },
    inventoryModel(t) {
      if (t) {
        var defaultItem = t.defaultItem;
        //|| this.defaultFn(t.tbl);
        var model = {};

        if (defaultItem) {
          model = {
            ...model,
            ...defaultItem,
          };
        }
      }

      if (t && t.r) {
        var item = t.r;

        model.item = item.item_name || item;
        model.volume = item.cu_ft || 0;
        model.qty = 1;
        model.room = model.room || t.r.room || "Any Room";
      }
      this.$root.$emit("volumeChanged");

      return model;
    },

    setTableProperties(e, model, data_object) {
      var that = this;
      var options = {
        data: e.table_properties,
        model: model,
        title: e.object_type,
      };
      e["v-bind"].rowIcons = function(r) {
        var icons = [];
        if (r.item.flight_of_stairs) {
          icons.push({
            icon: "mdi-stairs",
            title: r.item.flight_of_stairs,
            color: "red",
          });
        }
        if (r.item.elevator) {
          icons.push({
            icon: "mdi-elevator",
          });
        }
        if (icons.length) {
          return icons;
        }
      };
    },
    getMenu(menuName) {
      var that = this;
      var items = [];
      switch (menuName) {
        case "status":
          this.data_object.additional_model.lead_status.forEach((d) => {
            items.push({
              itemText: d.status,
              itemValue: d.status,
              click: function(p) {
                //
              },
            });
          });
          return items;
        default:
          break;
      }
    },
    populateLetter(body) {
      return body;
    },
    recalculateService(c, i) {
      this.calculateRoute(c, true);
    },
    letterContainer(obj) {
      var that = this;
      var d = obj.obj;
      // this.getTotalEstimate(this.model);

      var data = {
        object_name: "document",
        qry: {
          _id: d.item.value,
        },
        additional_data: [
          {
            obj_name: "v_shipment_letter_fields",

            qry: {
              shipment_id: parseInt(that.shipment_id),
            },
          },
        ],
      };
      this.loading = true;
      axios
        .post(that.serverURL + "/get_data", data, {
          withCredentials: true,
        })
        .then((response) => {
          let model = response.data.model;
          if (!this.data_object.additional_model) {
            this.data_object.additional_model = {};
          }
          this.data_object.additional_model.v_shipment_letter_fields =
            response.data.additional_model.v_shipment_letter_fields;

          that.fixLetterModel();

          var decoded = fun.decodeHtml(model[0].body);
          var bodyTemplate = fun.replaceLetterFields(decoded);
          if (this.shipmentObject.additionalModel.company.length > 1) {
            var company = this.shipmentObject.additionalModel.company.filter(
              (c) => {
                return c._id == this.model.shipment_detail.company;
              }
            )[0];
          }
          var introBody = model[0].intro_body
            ? fun.replaceLetterFields(model[0].intro_body)
            : "";
          var fixFields = function(b) {
            b = b
              .replaceAll(
                "estimate['non-binding'].shipment_service[0]",
                "service"
              )
              .replaceAll(
                "estimate['non-binding'].shipment_service",
                "services"
              );
            return b;
          };
          that.letterReady = false;
          obj.letterBind = {
            email: that.model.customer.contact.email,
            companyId: that.model.shipment_detail.company._id,
            documentId: d.id,
            model: that.letterModel,
            shipmentModel: that.model,
            documentModel: model[0],
            bodyTemplate: "<div>" + fixFields(bodyTemplate) + "</div>",
            introBodyTemplate: "<div>" + fixFields(introBody) + "</div>",
          };
          var myTab = that.dataTabs.filter((t) => {
            if (t.obj.obj && t.obj.obj.item) {
              return t.obj.obj.item.value == d.item.value;
            }
          });
          if (myTab.length) {
            myTab[0].letterBind = obj.letterBind;
          }
          that.letterReady = true;
          that.loading = false;
          that.docKey = !that.docKey;
        })
        .catch((reason) => {
          errorsHandler(reason);
        });
    },

    sendMail() {
      this.loading = true;
      this.$refs.doc[0].sendMail((f) => {
        this.loading = false;
        this.hideSendBtn = true;
        if (f == "success") {
          this.successMessage = "Mail has been sent.";

          this.successMessageValue = true;
        } else {
          this.errorMessage = "Error occured: " + f;
        }
      });
    },
    calculateInventoryVolume() {
      var inventory_volume = fun.calculateInventoryVolume(
        this.data_object.model.inventory
      );

      this.model.volume = inventory_volume
        ? parseFloat(inventory_volume).toFixed(1)
        : 0;
      this.model.weight = (inventory_volume * 7).toFixed(1);
    },
    calculateRoute(model, fn) {
      model.address = this.shipmentObject.model.customer.address.filter(
        (item1) =>
          model.shipment_stop.some(
            (item2) => item2.full_address === item1.full_address
          )
      );

      model.shipment_id = this.shipmentObject.model.shipment_id;
      model.service_index = this.serviceIndex;
      model.estimate_key = this.getEstimateKey(model);

      axios
        .post(this.serverURL + "/get_route", model, {
          withCredentials: true,
        })
        .then((response) => {
          var route = response.data;
          var distance = 0;
          var travelTime = 0;
          if (route.leg) {
            route.leg.forEach((l) => {
              distance += l.length;
              travelTime += l.travelTime;
            });
            model.distance = distance;
            model.mileage = (distance / 1.6 / 1000).toFixed(0);
            model.driving_time = (travelTime / 3600).toFixed(2);
            var defaultSettings = this.data_object.additional_model.company[0]
              .default_settings;
            model.service_type = defaultSettings.default_type_of_move;

            if (
              defaultSettings.local_states &&
              defaultSettings.local_states.length
            ) {
              var pickup = model.shipment_stop.filter((a) => {
                return a.value == "pickup";
              });
              var dropoff = model.shipment_stop.filter((a) => {
                return a.value == "dropoff";
              });
              if (pickup.length && dropoff.length) {
                var pickupLocation = model.address.find((a) => {
                  return a.full_address == pickup[0].full_address;
                });
                var dropOffLocation = model.address.find((a) => {
                  return a.full_address == dropoff[0].full_address;
                });
                var pickupState = fun.getObjectsByKey(
                  pickupLocation,
                  "stateCode"
                );
                var dropOffState = fun.getObjectsByKey(
                  dropOffLocation,
                  "stateCode"
                );
                if (pickupState) {
                  pickupState = pickupState[0];
                }
                if (dropOffState) {
                  dropOffState = dropOffState[0];
                }
                const normalizedStates = defaultSettings.local_states.map(
                  (state) => state.toLowerCase()
                );

                // Normalize the states to check
                const normalizedPickupState = pickupState.toLowerCase();
                const normalizedDropOffState = dropOffState.toLowerCase();

                // Check if both states are included in the array
                const pickupIncluded = normalizedStates.includes(
                  normalizedPickupState
                );
                const dropOffIncluded = normalizedStates.includes(
                  normalizedDropOffState
                );
                if (pickupIncluded && dropOffIncluded) {
                  if (
                    parseFloat(defaultSettings.radius) >=
                    parseFloat(model.mileage)
                  ) {
                    model.service_type = "local_moving";
                  } else {
                    model.service_type = "short_haul";
                  }
                } else {
                  model.service_type = "long_distance_moving";
                }
              }
            }

            if (route.leg && fn) {
              this.submit(false, true);
            }
          }

          // console.log(response)
        })
        .catch((reason) => {
          console.log(reason);
        });
    },
    getCaption() {
      if (this.model.shipment_id && this.mainService) {
        var caption = "";
        if (!this.$root.customerId) {
          caption +=
            " #" +
            (this.company && this.company.prefix ? this.company.prefix : "") +
            this.model.shipment_id +
            " ";

          if (
            this.model.shipment_detail &&
            this.model.shipment_detail.shipment_number
          ) {
            caption +=
              " Shipment #" + this.model.shipment_detail.shipment_number;
          }
          // var booked = this.mainService.booked ? "booked" : "not booked";
          if (!this.model.shipment_detail.status) {
            this.model.shipment_detail.status = this.model.lead_status;
          }
        }

        caption +=
          (this.wizardIndex != 1 || this.companyAssigned) && this.company
            ? this.company.company_name
            : "";
        return caption;
      } else {
        return "New Shipment";
      }
    },
    capitalize(v) {
      return fun.capitalize(v);
    },

    getDefaultService(model) {
      var that = this;
      if (model.estimate) {
        var estimate = model.estimate[Object.keys(model.estimate)[0]];
        var serviceTypes = this.data_object.additional_model.service_type;
        var moveType = model.shipment_detail.haul_type;
        serviceTypes = serviceTypes.filter(function(r) {
          return (
            (r.haul_type && r.haul_type.includes(moveType)) || !r.haul_type
          );
        });
      }
    },
    getCharges(service, service_type, estimate) {
      var charges = fun.clone(
        this.data_object.additional_structure.charges.properties
      );
      var that = this;
      var chargeTypes = that.data_object.additional_model.charge_category;
      var curChargeType = chargeTypes.filter(function(c) {
        return c.service_type.includes(service_type);
      });
      Object.keys(charges).forEach((c) => {
        var chargeIncludes = curChargeType.filter(function(t) {
          return t.charge_category == c;
        });
        if (chargeIncludes.length) {
          service.properties[c] = charges[c];
          service.properties[c].service_type = service_type;
          that.calculateCharges(service_type, estimate);
          that.setTableProperties(charges[c], {}, that.data_object);
        } else {
          var prop = fun.clone(service.properties);
          // console.log(prop);
          delete prop[c];
          service.properties = prop;

          //delete service.properties[c];
        }
      });
    },

    calculateCharges(serviceType, estimate) {
      // this.calculateLabor(serviceType, estimate);
    },

    filterTariff(update) {
      var model = this.data_object.model;
    },
    initShipment(model) {
      return this.testData;
    },
    getEstimate(model, serviceIndex) {
      var that = this;
      Object.keys(model.estimate).forEach((k) => {
        var estimate = model.estimate[k];
        if (
          !estimate.estimated_volume &&
          this.data_object.model.estimated_volume
        ) {
          estimate.estimated_volume = this.data_object.model.estimated_volume.toFixed(
            2
          );
        }
        if (
          !estimate.estimated_weight &&
          this.data_object.model.estimated_weight
        ) {
          estimate.estimated_weight = this.data_object.model.estimated_weight.toFixed(
            2
          );
        }
        if (!estimate.shipment_service) {
          estimate.shipment_service = [];
        }

        var service = estimate.shipment_service[serviceIndex];
        if (service) {
          if (
            !service.shipment_stop.filter((s) => {
              return s.full_address && s.full_address.indexOf("_") > -1;
            }).length
          ) {
            try {
              that.calculateRoute(service, true);
              // that.refreshShipment();
            } catch (error) {
              //
            }
            try {
              var zones = that.getZones();
              that.getZoneRate(that.zoneFrom, that.zoneTo);
            } catch (error) {
              //
            }
          }
        }
      });
    },
    compareObjects(par) {
      var lastTimeStamp = fun.formatDate(new Date(), false, true, true);
      var newObj = par.newObj || this.model;
      var oldObj = par.oldObj || this.originalModel;
      var exclude = par.exclude;
      var that = this;
      var arrayKey = par.arrayKey;
      var topObject = null;
      var parKey = "";
      var keys = [];
      if (!par.keys) {
        keys = [];
      } else {
        keys = keys.concat(par.keys);
      }
      var removeWrongKeys = function(v, obj) {
        var cloneKeys = fun.clone(keys);
        cloneKeys.forEach((k) => {
          if (obj && obj[k]) {
            try {
              if (JSON.stringify(obj[k]).indexOf(v) == -1) {
                keys.splice(keys.indexOf(k), 1);
              }
              removeWrongKeys(v, obj[k]);
            } catch (error) {
              //
            }
          }
        });
      };
      var getPath = function(myKey, v, obj) {
        removeWrongKeys(v, obj);
        if (!Array.isArray(obj)) {
          Object.keys(obj).forEach((k) => {
            if (k != exclude && k != "undefined") {
              if (obj[k] && typeof obj[k] == "object") {
                if (JSON.stringify(obj[k]).indexOf(v) != -1) {
                  keys.push(k);
                  getPath(k, v, obj[k]);
                }
              } else if (obj[k]) {
                if (obj[k] == v[k]) {
                  keys.push(k);
                }
              }
            }
          });
        }

        return keys;
      };

      var addtoModified = function(k, type, newValue, oldValue) {
        var v = "";
        if (!newValue) {
          newValue = "";
        }
        if (!oldValue) {
          oldValue = "";
        }
        var newData = newValue.toString().trim();
        var oldData = oldValue.toString().trim();
        var objToSeach = newObj;
        if (oldValue) {
          v = '"' + k + '"' + ":" + '"' + newValue + '"';
          newData = newValue;
        } else {
          v = JSON.stringify(newValue);
          if (type == "value removed") {
            oldData = JSON.stringify(newValue[k]);
            objToSeach = that.originalModel;
          }
        }

        if (type == "record deleted") {
          oldData = JSON.stringify(newValue);
        }
        var dateModified = new Date();

        var fullPath = "";

        if (!arrayKey) {
          fullPath = getPath(k, v, objToSeach);
        } else {
          fullPath = arrayKey;
        }
        if (type == "value added" || type == "record added") {
          newData = "";
        }
        var myPath = fun.clone(fullPath);
        if (arrayKey) {
          myPath = fun.clone(arrayKey);
        }
        if (!myPath) {
          myPath = [];
        }
        myPath.push(k);
        // var changedField = "";
        if (myPath.length > 2) {
          myPath = myPath.splice(myPath.length - 2);
        }
        var flds = [];
        myPath.forEach((p) => {
          // flds.push(fun.capitalize(p));
          flds.push(p);
        });
        try {
          if (k == "company") {
            oldData = that.shipmentObject.additionalModel.company.filter(
              (c) => {
                return c._id == oldData;
              }
            )[0].company_name;
            newData = that.shipmentObject.additionalModel.company.filter(
              (c) => {
                return c._id == newData;
              }
            )[0].company_name;
          }
        } catch (error) {
          //
        }
        try {
          if (k == "address" && flds.length == 2) {
            var stopType = that.activeTab.obj.obj;

            flds[0] = stopType;
          }
        } catch (error) {
          //
        }
        var capFilds = [];
        flds.forEach((f) => {
          capFilds.push(fun.capitalize(f));
        });

        var description = `${capFilds.join(" ")} changed from ${oldData ||
          "none"} to ${newData || "none"}`;
        var isObject = false;
        try {
          JSON.parse(oldData);
          isObject = true;
        } catch (error) {
          //
        }
        try {
          JSON.parse(newData);
          isObject = true;
        } catch (error) {
          //
        }
        var defaultData = ["origin_address", "destination_address"];
        if (oldData && !isObject && !defaultData.includes(oldData)) {
          var color = that.crmTypes.filter((s) => {
            return s.value == "history";
          })[0].color;
          var modRec = {
            type: k == "status" ? "status" : "history",
            description: description,
            new_data: newData,

            time_stamp: lastTimeStamp,
            user: that.currentUser,
            color: color,
          };
          var exists = that.modifiedRecords.some((r) => {
            return (
              r.description == modRec.description &&
              r.time_stamp == modRec.time_stamp
            );
          });

          if (!exists) {
            // if (lastTimeStamp == that.lastModified) {
            var curRec = that.modifiedRecords.find((m) => {
              return m.time_stamp == that.lastModified && m.type == modRec.type;
            });
            if (curRec) {
              if (!curRec.description.includes(description)) {
                curRec.description += "<br>" + description;
              }
            } else {
              that.modifiedRecords.push(modRec);
            }
          }
        }
      };

      var compareArrays = function(a, b, deleted) {
        if (a && b && Array.isArray(a) && Array.isArray(b)) {
          var status = "record added";
          if (deleted) {
            status = "record deleted";
          }
          var arrSchema = fun.getObjectByKey(
            that.data_object.schema.properties,
            parKey
          );
          if (arrSchema) {
            var nameKey = arrSchema.name_key;
          }
          if (!arrayKey) {
            arrayKey = [];
          }
          if (a.length == b.length) {
            status = "record changed";
            a.forEach((r, i) => {
              if (JSON.stringify(r) != JSON.stringify(b[i])) {
                arrayKey = getPath(parKey, JSON.stringify(r), newObj);

                if (nameKey) {
                  arrayKey.push(r[nameKey]);
                }
                try {
                  that.compareObjects({
                    newObj: r,
                    oldObj: b[i],
                    arrayKey: arrayKey,
                    keys: keys,
                  });
                } catch (error) {
                  //
                }
              }
            });
          } else {
            a.forEach((r) => {
              if (
                !b.filter((n) => {
                  return n._id == r._id;
                }).length
              ) {
                arrayKey = getPath(parKey, JSON.stringify(r), newObj);
                if (nameKey) {
                  arrayKey.push(r[nameKey]);
                }
                addtoModified("", status, r);
              }
            });
          }
        }
      };
      var comp = function(a, b) {
        if (Array.isArray(a)) {
          if (a.length >= b.length) {
            compareArrays(a, b);
          } else {
            compareArrays(b, a, true);
          }
        } else {
          if (a && b && Array.isArray(a) == Array.isArray(b)) {
            if (!topObject) {
              topObject = a;
            }
            var strA = JSON.stringify(a);
            var strTop = JSON.stringify(topObject);
            if (strA != strTop) {
              // object is not top object

              if (strTop.indexOf(strA) == -1) {
                //object is not child of top object
                topObject = a;
              }
            }
            var checkingObj = a;
            var comparableObj = b;
            var isKeyRemoved = Object.keys(b).length > Object.keys(a).length;
            if (isKeyRemoved) {
              checkingObj = b;
              comparableObj = a;
            }

            Object.keys(checkingObj).forEach((k) => {
              // if (checkingObj.geo) {
              //   console.log("geo");
              // }
              if (
                k != exclude &&
                k != "_id" &&
                (!checkingObj.geo || k == "address")
              ) {
                if (
                  JSON.stringify(checkingObj[k]) !=
                  JSON.stringify(comparableObj[k])
                ) {
                  parKey = k;
                  // changedKey.push(k);
                  if (typeof checkingObj[k] == "object") {
                    if (comparableObj[k]) {
                      comp(checkingObj[k], comparableObj[k]);
                    } else {
                      var action = "value added";
                      if (isKeyRemoved) {
                        action = "value removed";
                      }

                      addtoModified(k, action, checkingObj);
                    }
                  } else if (Array.isArray(checkingObj[k])) {
                    if (checkingObj[k].length >= comparableObj[k].length) {
                      //new obj added row or row modified
                      checkingObj[k].forEach((r, i) => {
                        if (comparableObj[k][i]) {
                          comp(r, comparableObj[k][i]);
                        } else {
                          addtoModified(k, "record added", r);
                        }
                      });
                    } else {
                      //new obj deleted row
                      comparableObj[k].forEach((r, i) => {
                        if (!checkingObj[k][i]) {
                          comp(r, comparableObj[k][i]);
                        } else {
                          addtoModified(parKey, "record deleted", r);
                        }
                      });
                    }
                  } else {
                    addtoModified(
                      k,
                      "value changed",
                      checkingObj[k],
                      comparableObj[k]
                    );
                  }
                }
              }
            });
          }
        }
      };

      comp(newObj, oldObj);
    },
    computedCurrentModel() {
      // if (!this.isClosing) {
      return this.currentModel;
    },
    compareModel() {
      this.lastModified = fun.formatDate(new Date(), false, true, true);
      var history = "crm";
      this.compareObjects({
        exclude: history,
      });

      this.originalModel = fun.clone(this.model);
      if (!this.model[history] || !this.model[history].length) {
        this.model[history] = [];
      }
      if (!this.model.crm) {
        this.model.crm = [];
      }

      this.model[history] = this.model[history].concat(this.modifiedRecords);
      this.model[history] = this.model[history].filter(
        (obj, index, self) =>
          index ===
          self.findIndex(
            (t) =>
              t.description === obj.description &&
              t.time_stamp === obj.time_stamp
          )
      );
    },

    onModelUpdated(model, schema, oldValue) {
      this.getEstimate(model);

      var that = this;

      that.getCaption(model);

      if (
        Array.isArray(that.data_object.company) &&
        that.data_object.company.length
      ) {
        that.data_object.company = that.data_object.company[0];
      }
      if (model && model.shipment_detail) {
        if (
          !model.shipment_detail.order_date ||
          typeof model.shipment_detail.order_date == "object"
        ) {
          model.shipment_detail.order_date = fun.getCurrentDateTime(true);
        }
      }
    },
  },
  watch: {
    serviceIndex() {
      var that = this;

      if (this.isClosing) {
        this.mainTab = 1;

        this.menuItemClick("closing");
        setTimeout(function() {
          that.mainTab = 0;
        }, 10);
      }
    },
    currentModel: {
      handler: function(newValue, oldValue) {
        // console.time();

        if (newValue && newValue.shipment_service && !this.isClosing) {
          this.calculateTotal(newValue.shipment_service);
        }
        // console.timeEnd();
      },
      deep: true,
    },
    model: {
      handler: function(newValue, oldValue) {
        var changed = {};
        if (!Object.keys(oldValue).length) {
          this.originalModel = fun.clone(newValue);
        }
      },
      deep: true,
    },
    activeTabIndex() {
      if (this.activeTabIndex == 0) {
        this.refreshData();
        if (this.$vuetify.breakpoint.smAndDown) {
          this.dataTabs = [];
        }
        this.removeClosingTab();
        // this.movePlanKey = !this.movePlanKey;
      }
      if (this.activeTab) {
        this.isPayment = false;
        if (!this.activeTab.obj.isLetter) {
          this.letterReady = false;
          this.isLetter = false;
        } else {
          this.letterReady = true;
          this.isLetter = true;
        }
        if (this.activeTab.obj.obj == "payment") {
          this.isPayment = true;
        }
      }
    },
  },
  computed: {},
};
</script>

<style lang="css">
.fixed-footer-toolbar {
  position: fixed;
  bottom: 20;
  left: 0;
  width: 100%;
}

.v-footer,
.bottom-bar {
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.move-plan-caption {
  /* background-color: green; */
  /* color: black; */
  font-weight: normal;
  padding: 4px;
  font-size: medium;
}

.snow {
  background-color: snow;
}

.v-tab {
  font-size: 12px !important;
}

@media only screen and (max-width: 450px) {
  .current-model-content {
    margin-top: -50px;
  }
  .main-wrap {
    max-width: 95%;
    overflow-x: hidden;
  }
  .fixed-footer-toolbar {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }

  .v-slide-group__content {
    /* display: block !important; */
  }
  .move-plan {
  }
  .move-plan-caption {
    /* background-color: green; */

    font-size: small;
  }

  .fixed-footer-toolbar {
    position: fixed;
    bottom: 0;
    width: 100%;
  }

  .v-tab {
    font-size: 12px;
  }
}

@media only screen and (min-width: 900px) {
  /* .main-wrap {
    height: 70vh;
  } */

  .fixed-footer-toolbar {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
  }
}

.grey {
  background-color: grey;
}

.tab-scrollable-content {
  max-height: 52vh;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
